<template>
  <div class="content-wrapper">
    <!-- Page Loader -->
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    </div>

    <breadcrumb :page="$t('form.student.editAlumni')"></breadcrumb>

    <div class="content">
      <div class="container-fluid">
        <back-button></back-button>
        <b-alert v-model="showDisableAlert" variant="info">
          {{ disableEditFormMessage }}
          <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
            <i class="fas fa-sync"></i>
          </button>
        </b-alert>

        <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{
          alertMessage
        }}</b-alert>

        <div class="card">
          <div class="card-header bg-light">
            <div class="card-title">{{ cardTitle }}</div>

            <div class="text-right">
              <button class="btn btn-primary" @click="updateStudent()" :disabled="disableEditForm || readonly">
                {{ $t("button.update") }}
              </button>

              <button class="btn btn-info" @click="updateStudent(true)" :disabled="disableEditForm || readonly">
                {{ $t("button.updateClose") }}
              </button>
            </div>
          </div>
          <div class="card-body">
            <b-tabs content-class="mt-3" v-model="tabIndex">
              <b-tab :title="$t('form.student.tabPersonal')" active>
                <div class="row">
                  <div class="col-sm-6 col-md-4">
                    <div class="row">
                      <div class="mt-3">
                        <input type="file" ref="profile_image" style="display: none" @input="showSelectedImage"
                          accept="image/*" />
                        <div v-if="student.Photo" class="position-relative" @mouseover="hovering = true"
                          @mouseleave="hovering = false">
                          <img :src="image" @dblclick="replaceImage" class="img-responsive"
                            style="cursor: pointer; max-width: 250px; max-height: 250px; border: 1px solid black" />

                          <div v-if="student.Photo"
                            class="icon-overlay position-absolute w-100 d-flex justify-content-center"
                            style="left: 0; right: 0; opacity: 0; transition: opacity 0.3s"
                            :style="{ opacity: hovering ? 1 : 0 }">
                            <button class="btn btn-sm btn-primary mx-2" @click="replaceImage">
                              <i class="fas fa-edit"></i>
                            </button><br>
                            <button class="btn btn-danger btn-sm mx-2" @click="confirmDelete">
                              <i class="fas fa-times-circle"></i>
                            </button>
                          </div>
                        </div>

                        <div v-else class="position-relative">
                          <img :src="image" @click="$refs.profile_image.click()" class="img-responsive"
                            style="cursor: pointer; max-width: 250px; max-height: 250px; border: 1px solid black" />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="form-group col-12">
                        <label>{{ $t("form.student.programStart") }}</label>
                        <date-picker class="date-picker" :lang="lang" v-model="student.ProgramStart"
                          :disabled="!permissions.editStudentsPersonalinformation" valueType="format"
                          :format="dateFormat" :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
                        </date-picker>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-6">
                        <label for="StudentPassportExpiryDate">{{
                          $t("form.student.passportExpiryDate")
                          }}</label>
                        <div class="d-flex">
                          <date-picker class="date-picker" :lang="lang"
                            :disabled="!permissions.editStudentsPersonalinformation" v-model="student.PassportExpiry"
                            :class="{ 'is-invalid': isInvalidDate }" valueType="format" :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>
                      <div class="form-group col-6">
                        <label for="StudentdPermitExpiryDate">{{
                          $t("form.student.permitExpiryDate")
                          }}</label>
                        <div class="d-flex">
                          <date-picker class="date-picker" :lang="lang"
                            :disabled="!permissions.editStudentsPersonalinformation"
                            :class="{ 'is-invalid': isInvalidDate2 }" v-model="student.PermitExpiry" valueType="format"
                            :format="dateFormat" :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
                          </date-picker>
                        </div>


                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-12">
                        <h5 class="font-weight-bold">
                          {{ $t("form.student.statusHistory") }}
                        </h5>
                        <table class="table table-bordered">
                          <tr>
                            <th>
                              {{ $t("form.student.status") }}
                            </th>
                            <th>
                              {{ $t("form.student.statusDate") }}
                            </th>
                            <th>
                              {{ $t("form.student.statusNote") }}
                            </th>
                            <th class="text-center" v-if="permissions.deleteStudentsStatushistory">
                              {{ $t("form.student.action") }}
                            </th>
                          </tr>
                          <tbody>
                            <tr v-for="(status, index) in studentStatus" v-bind:key="index">
                              <td>
                                {{ status.StudentStatusName }}
                              </td>
                              <td>
                                {{
                                  status.StudentStatusDate
                                  | formatDate(dateFormat)
                                }}
                              </td>
                              <td>
                                {{ status.StudentStatusComment }}
                              </td>
                              <td class="text-center" v-if="permissions.deleteStudentsStatushistory">
                                <button class="btn btn-danger btn btn-sm" v-on:click="deleteStatusEntry(index)">
                                  <span class="fa fa-trash"></span>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12">
                        <label>{{ $t("form.student.notes") }}</label>
                        <textarea name="Note" v-model="student.Notes" rows="3" class="form-control"></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12">
                        <label>{{ $t("form.student.linkedRecords") }}</label>

                        <ul class="list-group m-0">
                          <div class="input-group">
                              <input id="StudentNameField" type="text" class="form-control"
                                  placeholder="Search Student by Name"
                                  v-model="studentName"
                                  v-on:keyup="searchStudent()">
                              <div class="input-group-append">
                                  <span class="input-group-text remove_btn" v-on:click="clear()">
                                      <i class="fa fa-times"></i></span>
                              </div>

                          </div>

                          <li class="list-group-item" v-for="(student,index) in options" :key='index'>
                              <a @click="addLink(student)">
                                {{student.StudentNumber}} - {{student.FirstName}} {{student.LastName}}
                              </a>
                          </li>
                        </ul>

                        <ul class="list-group mt-2" v-if="linkedStudents.length">
                          <li
                            v-for="student in linkedStudents"
                            :key="student.id"
                            class="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <a @click="editAlumni(student.student_number)">
                              {{ student.full_name }} ({{ student.student_number }})
                            </a>
                            <button @click="removeLink(student.id)" class="btn btn-sm btn-danger">Unlink</button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-5">
                    <!-- // image partner -->
                    <div class="form-group">
                      <label for="StudentNumber">
                        {{ $t("form.student.studentNumber") }}
                        <span class="req" style="color: red">*</span>
                      </label>
                      <div class="controls">
                        <input id="StudentNumber" disabled name="StudentNumber" v-model="student.StudentNumber"
                          type="text" class="form-control" required="required" />
                      </div>
                    </div>
                    <div class="form-group" v-if="student.PartnerID == 1">
                      <label for="MatriculationNumField">
                        {{ $t("form.student.matriculationNum") }}
                      </label>
                      <input type="text" id="MatriculationNumField" class="form-control"
                        v-model.trim="$v.student.MatriculationNum.$model" :class="{
                          'is-invalid': $v.student.MatriculationNum.$error,
                        }" />
                      <div class="invalid-feedback" v-if="!$v.student.MatriculationNum.maxLength">
                        {{
                          $t("form.validation.maxDigits", {
                            num: $v.student.MatriculationNum.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="Title">{{ $t("form.student.title") }}</label>
                      <div class="controls">
                        <v-select :options="titles" :key="student.Title" v-model="student.Title"
                          :reduce="(titles) => titles">
                        </v-select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="FirstNameField">
                        {{ $t("form.student.firstName") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input type="text" id="FirstNameField" class="form-control" :class="{
                        'is-invalid': $v.student.FirstName.$error,
                      }" v-model.trim="$v.student.FirstName.$model" />
                      <div class="invalid-feedback" v-if="!$v.student.FirstName.required">
                        {{ $t("form.validation.required") }}
                      </div>
                      <div class="invalid-feedback" v-if="!$v.student.FirstName.maxLength">
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.FirstName.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="LastNameField">
                        {{ $t("form.student.lastName") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input type="text" id="LastNameField" class="form-control"
                        v-model.trim="$v.student.LastName.$model" :class="{
                          'is-invalid': $v.student.LastName.$error,
                        }" />
                      <div class="invalid-feedback" v-if="!$v.student.LastName.required">
                        {{ $t("form.validation.required") }}
                      </div>
                      <div class="invalid-feedback" v-if="!$v.student.LastName.maxLength">
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.LastName.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="TranscriptNameField">{{
                        $t("form.student.transcriptName")
                      }}</label>
                      <input type="text" id="TranscriptNameField" class="form-control"
                        v-model.trim="student.TranscriptName" />
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.birthDate") }}</label>
                      <date-picker :lang="lang" class="date-picker" v-model="student.BirthDate" valueType="format"
                        :format="dateFormat" :popup-style="{
                          top: '100%',
                          left: 0,
                        }" :append-to-body="false" :placeholder="student.BirthDate">
                      </date-picker>
                    </div>
                    <div class="form-group">
                      <label for="BirthPlaceField">
                        {{ $t("form.student.birthPlace") }}
                        <span class="req text-danger"></span>
                      </label>
                      <input type="text" id="BirthPlaceField" v-model.trim="$v.student.BirthPlace.$model"
                        class="form-control" :class="{
                          'is-invalid': $v.student.BirthPlace.$error,
                        }" />

                      <div class="invalid-feedback" v-if="!$v.student.BirthPlace.maxLength">
                        {{
                          $t("form.validation.maxLength", {
                            num: $v.student.BirthPlace.$params.maxLength.max,
                          })
                        }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>
                        {{ $t("form.student.birthCountry") }}
                      </label>
                      <v-select label="printable_name" :options="countries" v-model="student.BirthCountry"
                        :reduce="(countries) => countries.printable_name" :key="student.BirthCountry">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.nationality") }}</label>
                      <input type="text" v-model.trim="student.Nationality" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.streetAddress") }}</label>
                      <input type="text" v-model.trim="student.StreetAddress" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.city") }}</label>
                      <input type="text" v-model.trim="student.City" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.zip") }}</label>
                      <input type="text" v-model.trim="student.Zip" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label for="CountryField">{{
                        $t("form.student.country")
                      }}</label>
                      <v-select label="printable_name" :options="countries" v-model.trim="student.Country"
                        :reduce="(countries) => countries.printable_name" :key="student.Country">
                      </v-select>
                    </div>

                    <div class="form-group">
                      <label for="PhoneField">{{
                        $t("form.student.phone")
                      }}</label>
                      <input type="text" id="PhoneField" v-model.trim="student.Phone" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label for="MobileField">
                        {{ $t("form.student.mobile") }}
                      </label>
                      <div class="d-flex align-items-center">
                        <input type="text" id="MobileField" v-model.trim="student.Mobile" class="form-control" />
                        <a :href="`tel:${student.Mobile}`" class="btn btn-default text-nowrap">{{ $t("button.call")
                          }}</a>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="EmailField">
                        {{ $t("form.student.email") }}
                        <span class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-center">
                        <input type="email" id="EmailField" v-model.trim="$v.student.Email.$model" class="form-control"
                          :class="{
                            'is-invalid': $v.student.Email.$error,
                          }" />
                        <a :href="`mailto:${student.Email}`" class="btn btn-default text-nowrap">{{ $t("button.email")
                          }}</a>
                      </div>
                      <div class="invalid-feedback d-block" v-if="!$v.student.Email.required">
                        {{ $t("form.validation.required") }}
                      </div>
                      <div class="invalid-feedback d-block" v-if="!$v.student.Email.email">
                        {{ $t("form.validation.validEmail") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="Email2Field">{{
                        $t("form.student.email2")
                      }}</label>
                      <div class="d-flex">
                        <input id="Email2Field" name="Email2" v-model="student.Email2" type="text"
                          class="form-control" />
                        <a :href="`mailto:${student.Email2}`" class="btn btn-default text-nowrap">{{ $t("button.email")
                          }}</a>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="Email3Field">{{
                        $t("form.student.email3")
                      }}</label>
                      <div class="d-flex">
                        <input id="Email3Field" name="Email3" v-model="student.Email3" type="text"
                          class="form-control" />
                        <a :href="`mailto:${student.Email3}`" class="btn btn-default text-nowrap">{{ $t("button.email")
                          }}</a>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-3 mb-3 ml-auto">
                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.mailAddress") }}</b>
                        </u>
                      </h6>
                      <div class="form-group">
                        <label>
                          <input type="radio" v-model="student.MailAddress" value="1" />
                          {{ $t("form.student.mailAddressOption1") }}
                        </label>
                      </div>
                      <div class="form-group">
                        <label>
                          <input type="radio" v-model="student.MailAddress" value="2" />
                          {{ $t("form.student.mailAddressOption2") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.exportAddress") }}</b>
                        </u>
                      </h6>
                      <button class="btn btn-primary" @click="generate('pdf')">
                        <i class="fas fa-file-pdf"></i>
                      </button>

                      <button class="btn btn-primary" @click="generate('word')">
                        <i class="fas fa-file-word"></i>
                      </button>

                      <button class="btn btn-primary" @click="generate('text')">
                        <i class="far fa-file-alt"></i>
                      </button>
                    </div>
                    <div class="shadow mb-4 p-3">
                      <u>
                        <b>{{ $t("form.student.gradeNotify") }}</b>
                      </u>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" v-model="student.SISEnabled" />
                          {{ $t("form.student.gradeNotifyOption1") }}
                        </label>
                        <br />
                      </div>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" v-model="student.GradeNotification" />
                          {{ $t("form.student.gradeNotifyOption2") }}
                        </label>
                      </div>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" v-model="student.BirthdayNotification" />
                          {{ $t("form.student.gradeNotifyOption3") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <h6>
                        <u>
                          <b>{{ $t("form.student.legalization") }}</b>
                        </u>
                      </h6>
                      <div class="form-group">
                        <label>
                          <input type="checkbox" v-model="student.LegalizationRequired" />
                          {{ $t("form.student.legalizationOption1") }}
                        </label>
                      </div>
                    </div>

                    <div class="shadow mb-4 p-3">
                      <div class="form-group">
                        <label for="Code">{{
                          $t("form.student.partnerCode")
                        }}</label>
                        <div class="controls" v-if="partners.length">
                          <v-select label="PartnerCode" :options="partners" v-model="student.PartnerID"
                            :key="student.PartnerID" @input="selectedPartner" :reduce="(partners) => partners.PartnerID"
                            :disabled="partnersDisabled">
                          </v-select>
                        </div>
                      </div>
                      <div class="form-group" style="padding-bottom: 10%">
                        <label for="pCode">{{
                          $t("form.student.partnerCampus")
                        }}</label>
                        <div v-if="partnercampus.length">
                          <v-select label="PartnerCampusLocation" :options="partnercampus"
                            :key="student.PartnerCampusID" v-model="student.PartnerCampusID" :reduce="(partnercampus) => partnercampus.PartnerCampusID" track-by="PartnerCampusID">
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabBusiness')">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t("form.student.companyName") }}</label>
                      <input type="text" v-model.trim="studentBussiness.CompanyName" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label for="Department">{{
                        $t("form.student.department")
                      }}</label>
                      <input type="text" id="Department" v-model.trim="studentBussiness.Department"
                        class="form-control" />
                    </div>

                    <div class="form-group">
                      <label for="PositionField">{{
                        $t("form.student.position")
                      }}</label>
                      <input type="text" id="PositionField" v-model.trim="studentBussiness.Position"
                        class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.streetAddress") }}</label>
                      <input type="text" v-model.trim="studentBussiness.StreetAddress" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.city") }}</label>
                      <input type="text" v-model.trim="studentBussiness.City" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.zip") }}</label>
                      <input type="text" v-model.trim="studentBussiness.Zip" class="form-control" />
                    </div>

                    <div class="form-group">
                      <label>{{ $t("form.student.country") }}</label>
                      <v-select label="printable_name" :options="countries" v-model="studentBussiness.Country"
                        :key="studentBussiness.Country" :reduce="(countries) => countries.printable_name">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label for="PhoneFieldB">{{
                        $t("form.student.phone")
                      }}</label>
                      <div class="d-flex">
                        <input id="PhoneFieldB" name="Phone" v-model="studentBussiness.Phone" type="text"
                          class="form-control" />
                        <a :href="`tel:${studentBussiness.Phone}`" class="btn btn-default text-nowrap">{{
                          $t("button.call") }}</a>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="MobileFieldB">{{
                        $t("form.student.mobile")
                      }}</label>
                      <div class="d-flex">
                        <input id="MobileFieldB" name="Mobile" v-model="studentBussiness.Mobile" type="text"
                          class="form-control" />
                        <a :href="`tel:${studentBussiness.Mobile}`" class="btn btn-default text-nowrap">{{
                          $t("button.call") }}</a>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="FaxFieldB">{{
                        $t("form.student.fax")
                      }}</label>
                      <input id="FaxFieldB" name="Fax" v-model="studentBussiness.Fax" type="text"
                        class="form-control" />
                    </div>
                    <div class="form-group">
                      <label for="EmailFieldB">{{
                        $t("form.student.email")
                      }}</label>
                      <div class="d-flex">
                        <input id="EmailFieldB" name="Email" v-model="studentBussiness.Email" type="text"
                          class="form-control" />
                        <a :href="`mailto:${studentBussiness.Email}`" class="btn btn-default text-nowrap">{{
                          $t("button.email") }}</a>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="WebAddress:">{{
                        $t("form.student.webAddress")
                      }}</label>
                      <input id="WebAddress:" name="WebAddress" v-model="studentBussiness.WebAddress" type="text"
                        class="form-control" />
                    </div>
                    <div class="form-group">
                      <h5>
                        <b>
                          <u>{{ $t("form.student.contactPerson") }}</u>
                        </b>
                      </h5>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.title") }}</label>
                      <v-select :options="titles" v-model="studentBussiness.ContactPersonTitle"
                        :reduce="(contactPersonTitle) => contactPersonTitle"></v-select>
                    </div>
                    <div class="form-group">
                      <label for="ContactPersonFirstNameField">{{
                        $t("form.student.firstName")
                      }}</label>
                      <input type="text" id="ContactPersonFirstNameField"
                        v-model.trim="studentBussiness.ContactPersonFirstName" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label for="ContactPersonLastNameField">{{
                        $t("form.student.lastName")
                      }}</label>
                      <input id="ContactPersonLastNameField" v-model.trim="studentBussiness.ContactPersonLastName"
                        type="text" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label for="ContactPersonDepartmentField">{{
                        $t("form.student.department")
                      }}</label>
                      <input type="text" id="ContactPersonDepartmentField"
                        v-model.trim="studentBussiness.ContactPersonDepartment" class="form-control" />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="Notes:">{{ $t("form.student.notes") }}</label>
                      <textarea id="Notes:" name="Notes" v-model="studentBussiness.Notes" rows="15"
                        class="form-control"></textarea>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabRemarks')">
                <div class="form-group" v-if="student.ID" :key="student.ID">
                  <div class="mb-3">
                    <label>{{ $t("form.student.remarks") }}</label>
                    <b-button @click="downloadRemarks" class="float-right">
                      {{ $t("button.exportPDF") }}</b-button>
                  </div>
                  <summernote v-model="student.Remarks"></summernote>
                  <p class="text-muted">
                    {{ $t("form.student.remarksExportNote") }}
                  </p>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabAdmission')" class="position-relative">
                <div class="graduated-overlay" v-if="studentProgram.Graduate"></div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label for="EducationalBackground:">{{
                        $t("form.student.background")
                      }}</label>
                      <div class>
                        <textarea id="educationalbackground:" name="educationalbackground"
                          v-model="studentAdmission.EducationalBackground" rows="15" class="form-control"
                          data-role="textarea" data-parsley-errors-container="#errId40"></textarea>
                        <span id="errId40" class="error"></span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-7">
                    <label>{{ $t("form.student.bachelorAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox141">
                          <input type="checkbox" name="ExamAdmBBA" v-model="studentAdmission.ExamAdmBBA"
                            id="checkbox141" data-parsley-errors-container="#errId41" @change="changeCheck($event)"
                            value="0" />
                          {{ $t("form.student.admissionOption1") }}
                        </label>
                      </div>

                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="ExamAdmResultBBA" type="text" class="form-control" data-role="text"
                              data-parsley-errors-container="#errId42" name="ExamAdmResultBBA"
                              v-model="studentAdmission.ExamAdmResultBBA" :placeholder="$t('form.student.result')" />
                            <span id="errId42" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox143">
                          <input type="checkbox" id="checkbox143" name="ExamOthBBA"
                            v-model="studentAdmission.ExamOthBBA" data-parsley-errors-container="#errId41"
                            @change="changeCheck($event)" value="0" />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>

                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="result_other_b" type="text" name="ExamOthResultBBA"
                              v-model="studentAdmission.ExamOthResultBBA" class="form-control" data-role="text"
                              data-parsley-errors-container="#errId44" :placeholder="$t('form.student.result')" />
                            <span id="errId44" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <label>{{ $t("form.student.masterAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="checkbox149">
                          <input @change="changeCheck($event)" value="0" type="checkbox" name="ExamAdmMAS"
                            id="checkbox149" v-model="studentAdmission.ExamAdmMAS"
                            data-parsley-errors-container="#errId45" />
                          {{ $t("form.student.admissionOption1") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="result_entrance_m" type="text" class="form-control" data-role="text"
                              data-parsley-errors-container="#errId46" name="ExamAdmResultMAS"
                              v-model="studentAdmission.ExamAdmResultMAS" :placeholder="$t('form.student.result')" />
                            <span id="errId46" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamEntMAS">
                          <input type="checkbox" @change="changeCheck($event)" value="0" name="ExamEntMAS"
                            id="ExamEntMAS" v-model="studentAdmission.ExamEntMAS"
                            data-parsley-errors-container="#errId45" />
                          {{ $t("form.student.admissionOption2") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="result_admission_m" name="ExamEntResultMAS"
                              v-model="studentAdmission.ExamEntResultMAS" type="text" class="form-control"
                              data-role="text" data-parsley-errors-container="#errId47"
                              :placeholder="$t('form.student.result')" />
                            <span id="errId47" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamOthMAS">
                          <input @change="changeCheck($event)" value="0" type="checkbox" id="ExamOthMAS"
                            name="ExamOthMAS" v-model="studentAdmission.ExamOthMAS"
                            data-parsley-errors-container="#errId45" />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="ExamOthResultMAS" type="text" name="ExamOthResultMAS"
                              v-model="studentAdmission.ExamOthResultMAS" class="form-control" data-role="text"
                              data-parsley-errors-container="#errId48" :placeholder="$t('form.student.result')" />
                            <span id="errId48" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <label>{{ $t("form.student.doctorateAdmission") }}</label>
                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamEntDBA">
                          <input type="checkbox" @change="changeCheck($event)" value="0"
                            v-model="studentAdmission.ExamEntDBA" id="ExamEntDBA" name="ExamEntDBA"
                            data-parsley-errors-container="#errId49" />
                          {{ $t("form.student.admissionOption2") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="ExamEntResultDBA" name="ExamEntResultDBA"
                              v-model="studentAdmission.ExamEntResultDBA" type="text" class="form-control"
                              data-role="text" data-parsley-errors-container="#errId50"
                              :placeholder="$t('form.student.result')" />
                            <span id="errId50" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <label class="checkbox" for="ExamOthDBA">
                          <input type="checkbox" @change="changeCheck($event)" value="0"
                            v-model="studentAdmission.ExamOthDBA" id="ExamOthDBA" name="ExamOthDBA"
                            data-parsley-errors-container="#errId49" />
                          {{ $t("form.student.admissionOption3") }}
                        </label>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <div class>
                            <input id="ExamOthResultDBA" name="ExamOthResultDBA"
                              v-model="studentAdmission.ExamOthResultDBA" type="text" class="form-control"
                              data-role="text" data-parsley-errors-container="#errId51"
                              :placeholder="$t('form.student.result')" />
                            <span id="errId51" class="error"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabProgram')" class="position-relative">
                <div class="graduated-overlay" v-if="!permissions.editAlumniProgram"></div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class for="Program">{{
                        $t("form.student.program")
                      }}</label>
                      <div class>
                        <v-select label="FullTitle" :options="programs" v-model="studentProgram.ProgramID"
                          @input="selectProgram" :reduce="(programs) => programs.ID">
                        </v-select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="SecondrayMajor">
                        {{ $t("form.student.program2") }}
                      </label>
                      <div v-if="secondaryPrograms.length">
                        <v-select label="FullTitle" :options="secondaryPrograms" v-model="studentProgram2Title"
                          :key="studentProgram.Program2ID" :reduce="(secondaryPrograms) => secondaryPrograms.ID"
                          :disabled="true">
                        </v-select>
                      </div>
                      <div v-else>
                        <select class="form-control" disabled>
                          <option value=""></option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="checkbox">
                        <input type="checkbox" @change="changeCheck($event)" value="0"
                          v-model="studentProgram.BooksIncluded" />
                        {{ $t("form.student.books") }}
                      </label>
                      <br />
                      <label class="checkbox">
                        <input type="checkbox" :checked="studentProgram.Graduate"
                          :disabled="!permissions.editAlumniProgram" name="graduatecheck" @change="changeCheck($event)"
                          v-model="graduatecheckbox" />
                        {{ $t("form.student.graduate") }}
                      </label>
                      <br />
                      <label class="checkbox">
                        <input type="checkbox" @change="changeCheck($event)" value="0"
                          v-model="studentProgram.Withdraw" />
                        {{ $t("form.student.withdrawn") }}
                      </label>
                    </div>

                    <div class="form-group">
                      <label for="ThesisSubject">{{
                        $t("form.student.thesisSubject")
                      }}</label>
                      <div class>
                        <textarea id="ThesisSubject" v-model.trim="$v.studentProgram.ThesisSubject.$model"
                          name="ThesisSubject" rows="3" class="form-control" data-role="textarea" :class="{
                            'is-invalid':
                              $v.studentProgram.ThesisSubject.$error,
                          }"></textarea>
                        <div class="invalid-feedback" v-if="!$v.studentProgram.ThesisSubject.maxLength">
                          {{
                            $t("form.validation.maxLength", {
                              num: $v.studentProgram.ThesisSubject.$params
                                .maxLength.max,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label for="DefenceExaminer">{{
                      $t("form.student.defenceExaminer")
                    }}</label>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.Examiner1"
                        :reduce="(professor) => professor.ID" :key="studentProgram.Examiner1">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.Examiner2"
                        :reduce="(professor) => professor.ID" :key="studentProgram.Examiner2">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.Examiner3"
                        :key="studentProgram.Examiner3" :reduce="(professor) => professor.ID">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.Examiner4"
                        :key="studentProgram.Examiner4" :reduce="(professor) => professor.ID">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label class="sr-only"></label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.Examiner5"
                        :key="studentProgram.Examiner5" :reduce="(professor) => professor.ID">
                      </v-select>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("form.student.thesisEvaluation") }}</label>
                      <div class="mb-3" v-if="studentProgram.ThesisEvaluation">
                        <a href="#" @click.prevent="
                          downloadThesisEvaluation(
                            studentProgram.ThesisEvaluation,
                            true
                          )
                          ">
                          {{
                            studentProgram.ThesisEvaluation.split("/").pop()
                          }}</a>
                        |
                        <a href="#" @click.prevent="
                          downloadThesisEvaluation(
                            studentProgram.ThesisEvaluation
                          )
                          ">{{ $t("button.view") }}</a>
                      </div>
                      <vue-dropzone ref="thesisEvaluationDropzone" id="thesisEvaluationDropzoneID"
                        :disabled="!permissions.editAlumniProgram" :options="thesisEvaluationDropzone"
                        @vdropzone-success="thesisEvaluationUploaded" @vdropzone-processing="isLoading = true"
                        v-on:vdropzone-sending="sendingEvent">
                      </vue-dropzone>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="GraduationDate">
                        {{ $t("form.student.graduateDate") }}
                      </label>
                      <div class>
                        <date-picker :lang="lang" class="date-picker" v-model="studentProgram.GraduationDate"
                          valueType="format" :format="dateFormat" :popup-style="{
                            top: '100%',
                            left: 0,
                          }" :append-to-body="false" :placeholder="studentProgram.GraduationDate">
                        </date-picker>
                        <span id="errId60" class="error"></span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class for="ThesisPercentage">{{
                        $t("form.student.thesisPercentage")
                      }}</label>
                      <div class>
                        <input id="ThesisPercentage" name="ThesisPercentage" type="number" class="form-control"
                          v-model.number="gradeDetails.Percentage" readonly />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="ThesisGrade">{{
                        $t("form.student.thesisGrade")
                      }}</label>
                      <div class v-if="gradeDetails.DescriptiveGrade != ''">
                        <input id="ThesisGrade" v-model.number="gradeDetails.DescriptiveGrade" name="ThesisGrade"
                          type="text" class="form-control" readonly />
                      </div>
                      <div class v-else>
                        <input id="ThesisGrade" v-model.number="gradeDetails.LocalGrade" name="ThesisGrade" type="text"
                          class="form-control" readonly />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="ThesisMentor">{{
                        $t("form.student.thesisMentor")
                      }}</label>
                      <v-select label="FullName" :options="professor" v-model="studentProgram.ThesisMentor"
                        :key="studentProgram.ThesisMentor" :reduce="(professor) => professor.ID">
                      </v-select>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabGrade')" class="position-relative">
                <div class="row">
                  <div class="col-md-9">
                    <div class="graduated-overlay" v-if="studentProgram.Graduate"></div>

                    <div class="table-responsive p-0">
                      <table class="table table-bordered">
                        <thead v-if="fpGrades && fpGrades.length">
                          <tr class="bg-light text-center">
                            <td colspan="9">
                              <h5>{{ $t("form.student.foundationGrades") }}</h5>
                            </td>
                          </tr>
                          <tr>
                            <th>{{ $t("form.student.course") }}</th>
                            <th>{{ $t("form.student.percentage") }}</th>
                            <th v-if="showLocalGrades" style="min-width: 90px">{{ localGradeLabel }} </th>
                            <th style="min-width: 90px">{{ $t("form.student.grade") }}</th>
                            <th>{{ $t("form.student.descGrade") }}</th>
                            <th>{{ $t("form.student.finalExam") }}</th>
                            <th
                              v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">
                              {{ $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">{{ $t("form.student.enroll") }}</th>
                            <th>{{ $t("form.student.action") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(line, index) in $v.fpGrades.$each.$iter" v-bind:key="index">
                            <td>{{ fpGrades[index].FullTitle }}</td>
                            <td>
                              <div class="form-group">
                                <input @keyup="
                                  getFpGrades(fpGrades[index])
                                  " type="text" class="form-control" v-model.trim="line.Percentage.$model"
                                  :class="{
                                    'is-invalid':
                                      line.Percentage.$error,
                                  }" />
                                <div class="invalid-feedback" v-if="!line.Percentage.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Percentage.$params
                                        .between.min,
                                      num2: line.Percentage.$params
                                        .between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td v-if="showLocalGrades">
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.LocalGrade.$model" :class="{
                                  'is-invalid':
                                    line.LocalGrade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.LocalGrade.$params
                                        .between.min,
                                      num2: line.LocalGrade.$params
                                        .between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.Grade.$model" :class="{
                                  'is-invalid': line.Grade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.Grade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Grade.$params.between
                                        .min,
                                      num2: line.Grade.$params.between
                                        .max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <select v-model="fpGrades[index].DescriptiveGrade" class="form-control">
                                <option v-for="(
descriptiveGrade, index
                                          ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                  {{ descriptiveGrade }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <date-picker :lang="lang" class="date-picker" v-model="fpGrades[index].FinalExameDate"
                                valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false">
                              </date-picker>
                            </td>
                            <td
                              v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">
                              <input disabled type="text" class="form-control"
                                :value="fpGrades[index].isNew ? fpGrades[index].SBSCredits : getSBSCreditsFoundationProgram(fpGrades[index].FullTitle)" />
                            </td>
                            <td v-else>
                              <input disabled type="text" class="form-control"
                                :value="fpGrades[index].isNew ? fpGrades[index].ECTSCredits : getECTSCreditsFoundationProgram(fpGrades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                              <input type="checkbox" v-model="fpGrades[index].Enrolled" @change="changeCheck($event)"
                                value="0" />
                            </td>
                            <td>
                              <button type="button" class="btn btn-danger text-white btn-sm"
                                @click="removeFpGrade(index)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="fpGrades.length">
                            <td colspan="6" style="text-align: end;">
                              <strong
                                v-if="foundationProgram.ProgramCode == 'DBA' || foundationProgram.ProgramType == 'CAP Program'">Total
                                SBS Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{
                              calculateTotalCreditsFP() }}
                            </td>
                          </tr>
                        </tbody>
                        <thead>
                          <tr v-if="secondaryGrades.length || fpGrades.length" class="bg-light text-center">
                            <td colspan="8">
                              <h5>
                                {{ $t("form.student.primaryGrades") }}
                              </h5>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              {{ $t("form.student.course") }}
                            </th>
                            <th>
                              {{ $t("form.student.percentage") }}
                            </th>
                            <th v-if="showLocalGrades" style="min-width: 90px">
                              {{ localGradeLabel }}
                            </th>
                            <th style="min-width: 90px">
                              {{ $t("form.student.grade") }}
                            </th>
                            <th>
                              {{ $t("form.student.descGrade") }}
                            </th>
                            <th>
                              {{ $t("form.student.finalExam") }}
                            </th>
                            <th v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">{{
                              $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">
                              {{ $t("form.student.enroll") }}
                            </th>
                            <th>
                              {{ $t("form.student.action") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(line, index) in $v.grades.$each.$iter" v-bind:key="index">
                            <td>
                              {{ grades[index].FullTitle }}
                            </td>
                            <td>
                              <div class="form-group">
                                <input @keyup="getGrade(grades[index])" type="text" class="form-control"
                                  v-model.trim="line.Percentage.$model" :class="{
                                    'is-invalid': line.Percentage.$error,
                                  }" />
                                <div class="invalid-feedback" v-if="!line.Percentage.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Percentage.$params.between.min,
                                      num2: line.Percentage.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td v-if="showLocalGrades">
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.LocalGrade.$model" :class="{
                                  'is-invalid': line.LocalGrade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.LocalGrade.$params.between.min,
                                      num2: line.LocalGrade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.Grade.$model" :class="{
                                  'is-invalid': line.Grade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.Grade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Grade.$params.between.min,
                                      num2: line.Grade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <select v-model="grades[index].DescriptiveGrade" class="form-control">
                                <option v-for="(
descriptiveGrade, index
                                  ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                  {{ descriptiveGrade }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <date-picker :lang="lang" class="date-picker" v-model="grades[index].FinalExameDate"
                                valueType="format" :format="dateFormat" :popup-style="{
                                  top: '100%',
                                  left: 0,
                                }" :append-to-body="false">
                              </date-picker>
                            </td>
                            <td v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">
                              <input disabled type="text" class="form-control"
                                :value="getSBSCreditsProgram1(grades[index].FullTitle)" />
                            </td>
                            <td v-else>
                              <input disabled type="text" class="form-control"
                                :value="getECTSCreditsProgram1(grades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                              <input type="checkbox" v-model="grades[index].Enrolled" @change="changeCheck($event)"
                                value="0" />
                            </td>
                            <td>
                              <a class="btn btn-danger text-white btn-sm" @click="removeGrade(index)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="grades.length">
                            <td colspan="6" style="text-align: end;">
                              <strong v-if="selectedProgramCode == 'DBA' || program1Type == 'CAP Program'">Total SBS
                                Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ calculateTotalCredits1()
                              }}
                            </td>
                          </tr>
                        </tbody>
                        <thead v-if="secondaryGrades.length">
                          <tr v-if="secondaryGrades.length" class="bg-light text-center">
                            <td colspan="8">
                              <h5>
                                {{ $t("form.student.secondaryGrades") }}
                              </h5>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              {{ $t("form.student.course") }}
                            </th>
                            <th>
                              {{ $t("form.student.percentage") }}
                            </th>
                            <th v-if="showSecondaryLocalGrades" style="min-width: 90px">
                              {{ localGradeLabel }}
                            </th>
                            <th style="min-width: 90px">
                              {{ $t("form.student.grade") }}
                            </th>
                            <th>
                              {{ $t("form.student.descGrade") }}
                            </th>
                            <th>
                              {{ $t("form.student.finalExam") }}
                            </th>
                            <th v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">{{
                              $t("form.student.sbsCredits") }}</th>
                            <th v-else>{{ $t("form.student.ectsCredits") }}</th>
                            <th v-if="userPartnerCode === 'SBS'">
                              {{ $t("form.student.enroll") }}
                            </th>
                            <th>
                              {{ $t("form.student.action") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(line, index) in $v.secondaryGrades.$each
                            .$iter" v-bind:key="index">
                            <td>
                              {{ secondaryGrades[index].FullTitle }}
                            </td>
                            <td>
                              <div class="form-group">
                                <input @keyup="getGrade(secondaryGrades[index])" type="text" class="form-control"
                                  v-model.trim="line.Percentage.$model" :class="{
                                    'is-invalid': line.Percentage.$error,
                                  }" />
                                <div class="invalid-feedback" v-if="!line.Percentage.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Percentage.$params.between.min,
                                      num2: line.Percentage.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td v-if="showSecondaryLocalGrades">
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.LocalGrade.$model" :class="{
                                  'is-invalid': line.LocalGrade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.LocalGrade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.LocalGrade.$params.between.min,
                                      num2: line.LocalGrade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="form-group">
                                <input type="text" class="form-control" v-model.trim="line.Grade.$model" :class="{
                                  'is-invalid': line.Grade.$error,
                                }" />
                                <div class="invalid-feedback" v-if="!line.Grade.between">
                                  {{
                                    $t("form.validation.between", {
                                      num1: line.Grade.$params.between.min,
                                      num2: line.Grade.$params.between.max,
                                    })
                                  }}
                                </div>
                              </div>
                            </td>
                            <td>
                              <select v-model="secondaryGrades[index].DescriptiveGrade
                                " class="form-control">
                                <option v-for="(
descriptiveGrade, index
                                  ) in descriptiveGrades" v-bind:key="index" :value="descriptiveGrade">
                                  {{ descriptiveGrade }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <date-picker :lang="lang" class="date-picker"
                                v-model="secondaryGrades[index].FinalExameDate" valueType="format" :format="dateFormat"
                                :popup-style="{
                                  top: '100%',
                                  left: 0,
                                }" :append-to-body="false">
                              </date-picker>
                            </td>
                            <td v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">
                              <input disabled type="text" class="form-control"
                                :value="getSBSCreditsProgram2(secondaryGrades[index].FullTitle)" />
                            </td>
                            <td v-else>
                              <input disabled type="text" class="form-control"
                                :value="getECTSCreditsProgram2(secondaryGrades[index].FullTitle)" />
                            </td>
                            <td v-if="userPartnerCode === 'SBS'">
                              <input type="checkbox" v-model="secondaryGrades[index].Enrolled"
                                @change="changeCheck($event)" value="0" />
                            </td>
                            <td>
                              <a class="btn btn-danger btn-sm text-white" @click="removeSecondaryGrade(index)">
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="secondaryGrades.length">
                            <td colspan="7" style="text-align: end;">
                              <strong v-if="selectedProgram2Code == 'DBA' || program2Type == 'CAP Program'">Total SBS
                                Credits:</strong><strong v-else>Total ECTS Credits:</strong> {{ calculateTotalCredits2()
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group grades-btns">
                      <div class="row" v-if="fpGrades && fpGrades.length">
                        <div class="text-center">
                          <span class="gpa-box">{{ $t("form.student.fpGpa") }}
                            <strong>{{ fpGpa }}</strong></span>
                        </div>
                        <div class="text-center" v-if="showLocalGrades">
                          <span class="gpa-box">{{ $t("form.student.fpLocalGpa") }}
                            <strong>{{ fpLocalGpa }}</strong></span>
                        </div>
                      </div><br />
                      <div class="row">
                        <div class="text-center">
                          <span class="gpa-box">{{ $t("form.student.gpa") }}
                            <strong>{{ gpa }}</strong></span>
                        </div>
                        <div class="text-center" v-if="showLocalGrades || showSecondaryLocalGrades">
                          <span class="gpa-box">{{ $t("form.student.localGpa") }}
                            <strong>{{ localGpa }}</strong></span>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <b-button variant="danger" @click="exportGrades()">
                        <i class="fa fa-download" aria-hidden="true"></i>
                        {{ $t("button.exportPdf") }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabGraduation')" class="position-relative">
                <div class="graduated-overlay" v-if="studentProgram.Graduate"></div>
                <div class="row">
                  <div class="col-md-4">
                    <h5>
                      <u>
                        <b>{{ $t("form.student.bachelorProgram") }}</b>
                      </u>
                    </h5>

                    <br />

                    <div class="pl-3">
                      <div class="form-group mb-0">
                        <div>
                          <label>
                            <input type="checkbox" name="BBAExitSurvey" v-model="studentGraduateReq.BBAExitSurvey"
                              value="1" @change="changeCheck($event)" />
                            {{ $t("form.student.bachelorProgramOption1") }}
                          </label>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="checkbox">
                          <label>
                            <input value="1" @change="changeCheck($event)" type="checkbox" name="BBAExitSurveyCBE"
                              v-model="studentGraduateReq.BBAExitSurveyCBE" />
                            {{ $t("form.student.bachelorProgramOption2") }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{ $t("form.student.masterProgram") }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input value="1" @change="changeCheck($event)" type="checkbox" name="MASExitSurvey"
                              v-model="studentGraduateReq.MASExitSurvey" />
                            {{ $t("form.student.masterProgramOption1") }}
                          </label>
                        </div>
                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input value="1" @change="changeCheck($event)" type="checkbox" name="MSCInternReport"
                                v-model="studentGraduateReq.MSCInternReport" />
                              {{ $t("form.student.masterProgramOption4") }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{
                            $t(
                              "form.student.continuingEducation"
                            )
                          }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input value="1" @change="
                              changeCheck(
                                $event
                              )
                              " type="checkbox" name="DBAExitSurvey" :disabled="!permissions.editStudentsGraduationrequirements
                                                              " v-model="studentGraduateReq.CEExitSurvey
                                                              " />
                            {{
                              $t(
                                "form.student.doctorateProgramOption1"
                              )
                            }}
                          </label>
                        </div>
                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input value="1" @change="
                                changeCheck(
                                  $event
                                );
                              clearExamScore();
                              " type="checkbox" name="MASExitExamSBS" :disabled="!permissions.editStudentsGraduationrequirements
                                                                  " v-model="studentGraduateReq.MASExitExamSBS
                                                                  " />
                              {{
                                $t(
                                  "form.student.masterProgramOption2"
                                )
                              }}
                            </label>
                          </div>

                          <div class="form-group" v-if="
                            studentGraduateReq.MASExitExamSBS
                          ">
                            <div class>
                              <input type="text" class="form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                " v-model="studentGraduateReq.MASExitExamSBSResult
                                                                  " :placeholder="$t(
                                                                  'form.student.programScore'
                                                                )
                                                                  " />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <h5>
                        <u>
                          <b>{{ $t("form.student.doctorateProgram") }}</b>
                        </u>
                      </h5>
                      <br />
                      <div class="pl-3">
                        <div class="checkbox">
                          <label>
                            <input value="1" @change="changeCheck($event)" type="checkbox" name="DBAExitSurvey"
                              v-model="studentGraduateReq.DBAExitSurvey" />
                            {{ $t("form.student.doctorateProgramOption1") }}
                          </label>
                        </div>

                        <div class="form-group mb-0">
                          <div class="checkbox">
                            <label>
                              <input value="1" @change="
                                changeCheck($event);
                              clearExamScore();
                              " type="checkbox" name="DBAExitExamSBS" v-model="studentGraduateReq.DBAExitExamSBS" />
                              {{ $t("form.student.doctorateProgramOption2") }}
                            </label>
                          </div>
                          <div class="form-group" v-if="studentGraduateReq.DBAExitExamSBS">
                            <div class>
                              <input type="text" class="form-control" v-model="studentGraduateReq.DBAExitExamSBSResult
                                " :placeholder="$t('form.student.programScore')" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <h5>
                          <u>
                            <b>{{ $t("form.student.allPrograms") }}</b>
                          </u>
                        </h5>
                        <br />

                        <div class="pl-3">
                          <div class="checkbox">
                            <label>
                              <input value="1" @change="changeCheck($event)" type="checkbox" name="PassingGPA"
                                v-model="studentGraduateReq.PassingGPA" />
                              {{ $t("form.student.allProgramsOption1") }}
                            </label>
                          </div>

                          <div class="form-group">
                            <div class="checkbox">
                              <label>
                                <input value="1" @change="changeCheck($event)" type="checkbox"
                                  name="FinancialObligations" v-model="studentGraduateReq.FinancialObligations
                                    " />
                                {{ $t("form.student.allProgramsOption2") }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-8" v-if="selectedProgramCode == 'DBA'">
                    <h5>
                      <u>
                        <b>{{ $t("form.student.dba") }}</b>
                      </u>
                    </h5>

                    <br />

                    <div class="pl-3">
                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.ethicsApprovalDoc")
                        }}</label>
                        <input type="text" class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBAEthicsApprovalDoc" />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.approvedDate")
                        }}</label>
                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBAEApprovalDate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.statisticsExamDate")
                        }}</label>
                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBAStatsExamDate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.statisticsExamResult")
                        }}</label>
                        <input type="text" class="col-md-7 form-control"
                          v-model="studentGraduateReq.DBAStatsExamResult" />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.compsDate")
                        }}</label>

                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBACompsDate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.compsResult")
                        }}</label>
                        <input type="text" class="col-md-7 form-control" v-model="studentGraduateReq.DBACompsResult" />
                      </div>

                      <div class="form-group">
                        <label>
                          <input type="checkbox" name="DBAMAIssued" v-model="studentGraduateReq.DBAMAIssued"
                            @change="changeCheck($event)" />
                          {{ $t("form.student.mabrIssued") }}
                        </label>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.mabrDate")
                        }}</label>
                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBAMADate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.dissertation")
                        }}</label>
                        <input type="text" class="col-md-7 form-control" v-model="studentGraduateReq.DBADissertation" />
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.dissertationDate")
                        }}</label>
                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBADODDate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>

                      <div class="form-group">
                        <label>
                          <input value="1" @change="changeCheck($event)" type="checkbox" name="DBADegreeIssued"
                            v-model="studentGraduateReq.DBADegreeIssued" />
                          {{ $t("form.student.degreeIssued") }}
                        </label>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-4">{{
                          $t("form.student.degreeIssueDate")
                        }}</label>
                        <div class="col-md-7 p-0">
                          <date-picker :lang="lang" class="date-picker" v-model="studentGraduateReq.DBADegreeIssueDate"
                            valueType="format" :format="dateFormat" :popup-style="{
                              top: '100%',
                              left: 0,
                            }" :append-to-body="false">
                          </date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabAttachment')">
                <attachments :readonly="readonly" :isLoading="isLoading" :attachments="attachments"
                  :downloadAttachment="downloadAttachment" :removeAttachment="removeAttachment"
                  :attachmentUploaded="attachmentUploaded" :uploadFileError="uploadFileError"
                  :attachmentDropzone="attachmentDropzone" :getAttachmentFileName="getAttachmentFileName" />
              </b-tab>

              <b-tab :title="$t('form.student.tabAbsence')" v-if="showAbsencesTab" class="position-relative">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive p-0">
                      <table class="table table-bordered">
                        <tr>
                          <th>
                            {{ $t("form.student.absenceDate") }}
                          </th>
                          <th>
                            {{ $t("form.student.absenceReason") }}
                          </th>
                          <th>
                            {{ $t("form.student.absenceCourse") }}
                          </th>
                          <th>
                            {{ $t("form.student.absenceRemarks") }}
                          </th>
                          <th class="text-right">
                            {{ $t("form.student.action") }}
                          </th>
                        </tr>
                        <tbody>
                          <tr v-for="(StudentAbsence, index) in studentAbsences" v-bind:key="index">
                            <td>
                              {{ StudentAbsence.Date }}
                            </td>
                            <td>
                              {{ StudentAbsence.Reason }}
                            </td>
                            <td>
                              {{ StudentAbsence.course.CourseTitle }}
                            </td>
                            <td>
                              {{ StudentAbsence.Remarks }}
                            </td>
                            <td class="text-right">
                              <button class="btn btn-danger btn-sm" @click.prevent="removeAbsence(index)">
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab v-if="showApplicationTab" :title="$t('form.student.tabApplication')">
                <div class="row" v-if="studentProgram.ProgramID">
                  <div class="col-md-12">
                    <div class="table-responsive p-0">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>
                              {{ $t("form.student.sr") }}
                            </th>
                            <th>
                              {{ $t("form.student.reason") }}
                            </th>
                            <th>
                              {{ $t("form.student.file") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>

                        <tbody v-if="
                          selectedProgramCode == 'BBA' ||
                          selectedProgramCode == 'BSC'
                        ">
                          <tr>
                            <td>1</td>
                            <td>
                              {{ $t("form.student.completeCurriculumVitae") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.CurriculumVitae"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidCurriculumVitae
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              {{ $t("form.student.certifiedCopyHighSchool") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Degree"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidDegree" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              {{
                                $t("form.student.officialAcademicTranscripts")
                              }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.Transcript"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidTranscript" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              {{ $t("form.student.motivationLetter") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Letter"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidLetter" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              {{ $t("form.student.aSatScore") }}
                            </td>
                            <td>
                              <input type="number" class="form-control" v-model="studentApplication.Score" required />
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              {{ $t("form.student.englishProficiency") }}
                            </td>

                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.EnglishProficiency"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidEnglishProficiency
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>

                            <td>
                              {{ $t("form.student.onePicture") }}
                            </td>

                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Picture"></application-file>
                            </td>

                            <td>
                              <input v-model="studentApplication.ValidPicture" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>
                              {{ $t("form.student.passportCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PassportCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>9</td>
                            <td>
                              {{ $t("form.student.permitCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PermitCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>10</td>
                            <td>
                              {{ $t("form.student.additionalDocument") }}
                            </td>
                            <td colspan="2">
                              <application-file :isAlumni="true" :files="studentApplication.AdditionalDocuments" />
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="selectedProgramCode == 'AAE'">
                          <tr>
                            <td>1</td>
                            <td>
                              {{ $t("form.student.completeCurriculumVitae") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.CurriculumVitae" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidCurriculumVitae
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              {{ $t("form.student.certifiedCopyHighSchool") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Degree"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidDegree" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              {{
                                $t("form.student.officialAcademicTranscripts")
                              }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.Transcript"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidTranscript" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              {{ $t("form.student.associateDegree") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.AssociateDegree"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidAssociateDegree
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              {{ $t("form.student.aSatScore") }}
                            </td>
                            <td>
                              <input type="number" class="form-control" v-model="studentApplication.Score" required />
                            </td>

                            <td></td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              {{ $t("form.student.englishProficiency") }}
                            </td>

                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.EnglishProficiency"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidEnglishProficiency
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>

                            <td>
                              {{ $t("form.student.onePicture") }}
                            </td>

                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Picture"></application-file>
                            </td>

                            <td>
                              <input v-model="studentApplication.ValidPicture" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>
                              {{ $t("form.student.passportCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PassportCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox" disabled />
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>
                              {{ $t("form.student.permitCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PermitCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>10</td>
                            <td>
                              {{ $t("form.student.additionalDocument") }}
                            </td>
                            <td colspan="2">
                              <application-file :isAlumni="true" :files="studentApplication.CurriculumVitae" />
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="
                          selectedProgramCode == 'MSc' ||
                          selectedProgramCode == 'MBA' || 
                          selectedProgramCode == 'EMBA'
                        ">
                          <tr>
                            <td>1</td>
                            <td>
                              {{ $t("form.student.completeCurriculumVitae") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.CurriculumVitae"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidCurriculumVitae
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              {{ $t("form.student.certifiedCopyBachelor") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Degree"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidDegree" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              {{
                                $t("form.student.officialAcademicTranscripts")
                              }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.Transcript"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidTranscript" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              {{ $t("form.student.twoReferenceLetters") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Letter"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidLetter" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              {{ $t("form.student.onePicture") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Picture"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPicture" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              {{ $t("form.student.passportCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PassportCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>
                              {{ $t("form.student.permitCopy") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.PermitCopy" />
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>
                              {{ $t("form.student.additionalDocument") }}
                            </td>
                            <td colspan="2">
                              <application-file :isAlumni="true" :files="studentApplication.AdditionalDocuments" />
                            </td>
                          </tr>
                        </tbody>

                        <tbody v-if="selectedProgramCode == 'DBA'">
                          <tr>
                            <td>1</td>
                            <td>
                              {{ $t("form.student.completeCurriculumVitae") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.CurriculumVitae"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidCurriculumVitae
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>
                              {{ $t("form.student.certifiedCopyMaster") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Degree"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidDegree" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>
                              {{
                                $t("form.student.officialAcademicTranscripts")
                              }}
                            </td>
                            <td>
                              <application-file :isAlumni="true"
                                :files="studentApplication.Transcript"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidTranscript" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>
                              {{
                                $t("form.student.employmentConfirmationLetter")
                              }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Letter"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidLetter" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>
                              {{ $t("form.student.onePicture") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.Picture"></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPicture" type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>
                              {{ $t("form.student.researchInterestOutline") }}
                            </td>
                            <td>
                              <application-file :isAlumni="true" :files="studentApplication.ResearchInterestOutline
                                "></application-file>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidResearchInterestOutline
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>
                              {{ $t("form.student.passportCopy") }}
                            </td>
                            <td>
                              <ul class="p-0 mt-2">
                                <li v-for="(
file, index
                                  ) in studentApplication.PassportCopy" :key="index"
                                  class="d-flex justify-content-between">
                                  <a v-if="!file.path && !file.timestamp"
                                    :href="`/storage/students/applications/${file}`" target="_blank"
                                    :title="$t('form.student.openInNewTab')">{{ file.split("/").pop() }}</a>
                                  <a v-else :href="`/storage/students/applications/${file.path}`" target="_blank"
                                    :title="$t('form.student.openInNewTab')">{{ file.path.split("/").pop() }}</a>
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPassportCopy
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>
                              {{ $t("form.student.permitCopy") }}
                            </td>
                            <td>
                              <ul class="p-0 mt-2">
                                <li v-for="(
file, index
                                  ) in studentApplication.Permitexpiry" :key="index"
                                  class="d-flex justify-content-between">
                                  <a v-if="!file.path && !file.timestamp"
                                    :href="`/storage/students/applications/${file}`" target="_blank"
                                    :title="$t('form.student.openInNewTab')">{{ file.split("/").pop() }}</a>
                                  <a v-else :href="`/storage/students/applications/${file.path}`" target="_blank"
                                    :title="$t('form.student.openInNewTab')">{{ file.path.split("/").pop() }}</a>
                                </li>
                              </ul>
                            </td>
                            <td>
                              <input v-model="studentApplication.ValidPermitCopy
                                " type="checkbox" disabled />
                            </td>
                          </tr>

                          <tr>
                            <td>9</td>
                            <td>
                              {{ $t("form.student.additionalDocument") }}
                            </td>
                            <td colspan="2">
                              <application-file :isAlumni="true" :files="studentApplication.AdditionalDocuments" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabFinance')" v-if="showFinanceTab">
                <div class="mb-3 row">
                  <div class="form-group col-md-3">
                    <label>{{ $t("form.student.globalDiscount") }}</label>
                    <input type="text" class="form-control" v-model.trim="$v.studentFinance.GlobalDiscount.$model"
                      :class="{
                        'is-invalid': $v.studentFinance.GlobalDiscount.$error,
                      }" />
                    <div class="invalid-feedback" v-if="!$v.studentFinance.GlobalDiscount.maxLength">
                      {{
                        $t("form.validation.maxLength", {
                          num: $v.studentFinance.GlobalDiscount.$params
                            .maxLength.max,
                        })
                      }}
                    </div>
                    <div class="invalid-feedback" v-if="!$v.studentFinance.GlobalDiscount.decimal">
                      {{ $t("form.validation.numbersAllowed") }}
                    </div>
                    <div class="invalid-feedback" v-if="!$v.studentFinance.GlobalDiscount.between">
                      {{
                        $t("form.validation.between", {
                          num1: $v.studentFinance.GlobalDiscount.$params.between
                            .min,
                          num2: $v.studentFinance.GlobalDiscount.$params.between
                            .max,
                        })
                      }}
                    </div>
                  </div>
                  <div class="form-group col-md-3" v-if="permissions.viewSettingsReductiontypes">
                    <label>{{ $t("form.student.reduction_type") }}</label>
                    <select class="form-control" v-model="student_reduction">
                      <option value="">
                        {{ $t("form.student.select") }}
                      </option>
                      <option v-for="(type, index) in reduction_types" :value="type.name" :key="index">
                        {{ type.name | capitalize }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t("form.student.FullPaymentDiscount") }}</label>
                    <input type="text" class="form-control" v-model.trim="$v.studentFinance.FullPaymentDiscount.$model
                      " :class="{
                        'is-invalid':
                          $v.studentFinance.FullPaymentDiscount.$error,
                      }" />
                    <div class="invalid-feedback" v-if="!$v.studentFinance.FullPaymentDiscount.maxLength">
                      {{
                        $t("form.validation.maxLength", {
                          num: $v.studentFinance.FullPaymentDiscount.$params
                            .maxLength.max,
                        })
                      }}
                    </div>
                    <div class="invalid-feedback" v-if="!$v.studentFinance.FullPaymentDiscount.decimal">
                      {{ $t("form.validation.numbersAllowed") }}
                    </div>
                    <div class="invalid-feedback" v-if="!$v.studentFinance.FullPaymentDiscount.between">
                      {{
                        $t("form.validation.between", {
                          num1: $v.studentFinance.FullPaymentDiscount.$params
                            .between.min,
                          num2: $v.studentFinance.FullPaymentDiscount.$params
                            .between.max,
                        })
                      }}
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label>{{ $t("form.student.paymentPlan") }}</label>
                    <select class="form-control" v-model="student.PaymentPlan">
                      <option value="">
                        {{ $t("form.student.select") }}
                      </option>
                      <option v-for="(plan, index) in paymentPlans" :value="plan" :key="index">
                        {{ plan | capitalize }}
                      </option>
                    </select>
                  </div>
                </div>

                <hr />

                <div>
                  <div class="d-flex justify-content-between">
                    <h4>Invoices</h4>
                    <div class="form-group">
                      <select class="form-control" v-model="invoiceType" @change="getStudentInvoices()">
                        <option value="">
                          {{ $t("form.student.all") }}
                        </option>
                        <option value="1">
                          {{ $t("form.invoice.status_pending") }}
                        </option>
                        <option value="2">
                          {{ $t("form.invoice.status_approved") }}
                        </option>
                        <option value="3">
                          {{ $t("form.invoice.status_sent") }}
                        </option>
                        <option value="4">
                          {{ $t("form.invoice.status_paid") }}
                        </option>
                        <option value="5">
                          {{ $t("form.invoice.status_delivery_failed") }}
                        </option>
                        <option value="6">
                          {{ $t("form.invoice.status_course_date_pending") }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered" v-if="studentInvoices.length">
                      <thead>
                        <tr>
                          <th>
                            {{ $t("form.invoice.number") }}
                          </th>
                          <th>
                            {{ $t("form.invoice.date") }}
                          </th>
                          <th>
                            {{ $t("form.invoice.amount") }}
                          </th>
                          <th>
                            {{ $t("form.invoice.invoicePurpose") }}
                          </th>
                          <template v-if="student.PaymentPlan">
                            <th>
                              {{ $t("form.invoice.payment") }}
                            </th>
                            <th>
                              {{ $t("form.invoice.installment") }}
                            </th>
                          </template>
                          <th>
                            {{ $t("form.invoice.status") }}
                          </th>
                          <th class="text-right">
                            {{ $t("form.invoice.action") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody v-for="(invoice, index) in studentInvoices" v-bind:key="index">
                        <tr>
                          <td>
                            {{ invoice.InvoiceNumber }}
                          </td>
                          <td>
                            {{ invoice.InvoiceDate | formatDate(dateFormat) }}
                          </td>
                          <td>
                            <template v-if="
                              invoice.PaymentPlan == 'Full Payment' &&
                              !invoice.acceptanceFee
                            ">
                              {{ invoice.Currency }}
                              {{
                                invoice.FullPaymentDiscountedAmount
                                | curreny(
                                  decimalDigits,
                                  decimalPoint,
                                  thousandSeparator
                                )
                              }}
                              {{
                                student.GlobalDiscount > 0
                                  ? `( ${student.GlobalDiscount}% ${$t(
                                    "form.invoice.discount"
                                  )}
                              )`
                                  : null
                              }}
                            </template>
                            <template v-else-if="
                              Number(invoice.Discount) > 0 &&
                              invoice.PaymentPlan != 'Full Payment' &&
                              !invoice.acceptanceFee
                            ">
                              {{ invoice.Currency }}
                              {{
                                invoice.DiscountedAmount
                                | curreny(
                                  decimalDigits,
                                  decimalPoint,
                                  thousandSeparator
                                )
                              }}
                              ({{ invoice.Discount }}%
                              {{ $t("form.invoice.discount") }})
                            </template>
                            <template v-else>
                              {{ invoice.Currency }}
                              {{
                                invoice.Amount
                                | curreny(
                                  decimalDigits,
                                  decimalPoint,
                                  thousandSeparator
                                )
                              }}
                            </template>
                          </td>
                          <td>
                            {{ invoice.InvoicePurpose }}
                          </td>
                          <template v-if="student.PaymentPlan">
                            <td>
                              {{ invoice.PaymentPlan | capitalize }}
                            </td>
                            <td>
                              {{ invoice.Installment }}
                            </td>
                          </template>
                          <td v-if="invoice.Status == 1">
                            {{ $t("form.invoice.status_pending") }}
                          </td>
                          <td v-else-if="invoice.Status == 2">
                            {{ $t("form.invoice.status_approved") }}
                          </td>
                          <td v-else-if="invoice.Status == 3">
                            {{ $t("form.invoice.status_sent") }}
                          </td>
                          <td v-else-if="invoice.Status == 4">
                            {{ $t("form.invoice.status_paid") }}
                          </td>
                          <td v-else-if="invoice.Status == 5">
                            {{ $t("form.invoice.status_delivery_failed") }}
                          </td>
                          <td v-else-if="invoice.Status == 6">
                            {{ $t("form.invoice.course_date_pending") }}
                          </td>
                          <td v-else-if="
                            invoice.Status == null ||
                            invoice.Status == undefined ||
                            invoice.Status == 0
                          "></td>

                          <td class="text-right">
                            <button v-if="
                              permissions.viewInvoices
                            " @click="
                              goToShow(invoice.ID, invoice.Version)
                              " class="btn btn-dark btn-sm">
                              <i class="fa fa-print"></i>
                            </button>
                            <button v-if="
                              permissions.editInvoicesStudents
                            " @click="
                              goToEdit(invoice.ID)
                              " class="btn btn-info btn-sm">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button class="btn btn-danger btn btn-sm" v-on:click="deleteInvoice(invoice)"
                              v-show="permissions.deleteInvoicesAlumni">
                              <span class="fa fa-trash"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p v-else>{{ $t("noRecord") }}</p>
                  </div>
                  <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                    @paginate="paginate('invoice')">
                  </pagination>
                </div>
              </b-tab>

              <b-tab :title="$t('form.student.tabPaymentSummaries')" v-if="showPaymentSummaryTab" ref="summaryTab">
                <h3 class="mb-3">{{ $t("form.student.paymentSummaries") }}</h3>
                <div class="table-responsive">
                    <table class="table table-hover table-bordered" v-if="paymentSummaries.length">
                        <thead>
                            <tr>
                                <th>
                                    {{ $t("form.student.summaryNumber") }}
                                </th>
                                <th>
                                    {{ $t("form.student.status") }}
                                </th>
                                <th>
                                    {{ $t("form.student.date") }}
                                </th>
                                <th class="text-right">
                                    {{ $t("form.student.totalAmount") }}
                                </th>
                                <th class="text-right">
                                    {{ $t("form.student.action") }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr @dblclick="goToEditSummary(sps.id)" v-for="sps in paymentSummaries" :key="sps.id">
                                <td>
                                    {{ sps.reference_number }}
                                </td>
                                <td>
                                    {{ sps.status }}
                                </td>
                                <td>
                                    {{ sps.summary_date | formatDate(dateFormat) }}
                                </td>
                                <td class="text-right">
                                    {{ sps.currency }} {{ sps.total_amount | curreny(decimalDigits, decimalPoint, thousandSeparator) }}
                                </td>
                                
                                <td class="text-right">
                                    <button @click="goToShowSummary(sps.id)" class="btn btn-dark btn-sm">
                                        <i class="fa fa-print"></i>
                                    </button>
                                    <button @click="goToEditSummary(sps.id)" class="btn btn-info btn-sm">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button @click="deleteSummary(sps)" class="btn btn-danger btn-sm">
                                    <i class="fa fa-trash"></i>
                                    </button>                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>{{ $t("noRecord") }}</p>
                </div>

                <b-button class="mb-3" @click="$refs.paymentSummaryModal.show()">{{ $t("form.student.createPaymentSummary") }}</b-button>

                <b-modal
                    ref="paymentSummaryModal"
                    size="xl"
                    hide-footer
                    scrollable
                    :title="$t('form.student.createPaymentSummary')"
                >
                    <div class="mb-3 row">
                        <div class="form-group col-md-4">
                            <label>{{ $t("form.student.dateFrom") }}</label>
                            <date-picker
                                class="date-picker"
                                :lang="lang"
                                v-model="studentPaymentSummary.DateFrom"
                                valueType="format"
                                :format="dateFormat"
                                :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false"
                            >
                            </date-picker>
                        </div>

                        <div class="form-group col-md-4">
                            <label>{{ $t("form.student.dateTo") }}</label>
                            <date-picker
                                class="date-picker"
                                :lang="lang"
                                v-model="studentPaymentSummary.DateTo"
                                valueType="format"
                                :format="dateFormat"
                                :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false"
                            >
                            </date-picker>
                        </div>

                        <div class="form-group col-md-4 align-self-end">
                            <b-button @click="getPaymentData">
                        {{ $t("button.getPaymentData") }}</b-button>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="form-group col-md-12">
                            <label>{{ $t("form.student.summaryDate") }}</label>
                            <date-picker
                                class="date-picker"
                                :lang="lang"
                                v-model="studentPaymentSummary.SummaryDate"
                                valueType="format"
                                :format="dateFormat"
                                :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false"
                            >
                            </date-picker>
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{$t('form.student.currency')}}</label>
                            <v-select :options="currencies" v-model="studentPaymentSummary.Currency"
                                :reduce="currencies => currencies" :key="studentPaymentSummary.Currency">
                            </v-select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{ $t("form.student.titleText") }}</label>
                            <input type="text" v-model="studentPaymentSummary.TitleText" class="form-control" />
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{ $t("form.student.introText") }}</label>
                            <input type="text" v-model="studentPaymentSummary.IntroText" class="form-control" />
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{ $t("form.student.closingText") }}</label>
                            <input type="text" v-model="studentPaymentSummary.ClosingText" class="form-control" />
                        </div>
                        <div class="form-group col-md-12">
                            <label class="checkbox" :disabled="studentPaymentSummary.CustomGrouping">
                                <input 
                                    type="checkbox" 
                                    v-model="studentPaymentSummary.GroupByYear" 
                                    @change="handleGroupByYearChange"
                                />
                                {{ $t("form.student.groupByYear") }}
                            </label>
                            <label class="checkbox" :disabled="studentPaymentSummary.GroupByYear">
                                <input 
                                    type="checkbox" 
                                    v-model="studentPaymentSummary.CustomGrouping" 
                                    @change="handleCustomGroupingChange"
                                />
                                {{ $t("form.student.customGrouping") }}
                            </label>
                        </div>
                        <div class="form-group col-md-12">
                            <label>{{ $t("form.student.grandTotalLabel") }}</label>
                            <input type="text" v-model="studentPaymentSummary.GrandTotalLabel" class="form-control" 
                                :placeholder="$t('form.student.totalFeesPaidToDate')" />
                        </div>
                    </div>

                    <div class="row mb-3" v-if="paymentSummaryItems.length">
                        <div class="form-group col-md-12">
                            <div class="table-responsive">
                                <table class="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th style="width: 40px;">
                                                {{ $t("form.student.drag") }}
                                            </th>
                                            <th>
                                                {{ $t("form.student.amountReceived") }}
                                            </th>
                                            <th>
                                                {{ $t("form.student.invoiceNumber") }}
                                            </th>
                                            <th>
                                                {{ $t("form.student.dateFeesReceived") }}
                                            </th>
                                            <th v-if="studentPaymentSummary.GroupByYear">{{ $t("form.student.year") }}</th>
                                            <th v-if="studentPaymentSummary.CustomGrouping">{{ $t("form.student.groupNumber") }}</th>
                                            <th class="text-center" style="width: 100px;">
                                                {{ $t("form.student.sort_order") }}
                                            </th>
                                            <th class="text-right">
                                                {{ $t("form.student.action") }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(row, idx) in paymentSummaryItems">
                                            <!-- Group Separator -->
                                            <tr v-if="idx === 0 || getGroupKey(row) !== getGroupKey(paymentSummaryItems[idx-1])" class="table-secondary">
                                                <td v-if="studentPaymentSummary.GroupByYear || studentPaymentSummary.CustomGrouping" colspan="100" class="py-1 text-center text-muted">
                                                    <strong>Group: {{ getGroupKey(row) === 'no_year' ? 'No Year' : getGroupKey(row) }}</strong>
                                                </td>
                                            </tr>
                                            <tr :key="row.id || row.invoice_number || idx" class="draggable-row" :draggable="true" @dragstart="onDragStart($event, row)" @dragover="onDragOver" @drop="onDrop($event, row)">
                                                <td class="text-center align-middle" style="cursor: grab;">⋮⋮</td>
                                                <td>
                                                    <input type="number" step="0.01" v-model.number="row.amount_received" class="form-control" />
                                                </td>
                                                <td>
                                                    <input type="text" v-model="row.invoice_number" class="form-control" />
                                                </td>
                                                <td>
                                                    <date-picker
                                                        class="date-picker"
                                                        :lang="lang"
                                                        v-model="row.payment_date"
                                                        valueType="format"
                                                        :format="dateFormat"
                                                        :popup-style="{ top: '100%', left: 0 }"
                                                        :append-to-body="false"
                                                        @input="autoPopulateYear(row, idx)"
                                                    >
                                                    </date-picker>
                                                </td>
                                                <td v-if="studentPaymentSummary.GroupByYear">
                                                    <input 
                                                        type="text" 
                                                        v-model="row.year" 
                                                        maxlength="4" 
                                                        class="form-control" 
                                                        :placeholder="$t('form.student.year')"
                                                        @blur="sortPaymentSummaryItemsByYear"
                                                    />
                                                </td>
                                                <td v-if="studentPaymentSummary.CustomGrouping">
                                                    <input 
                                                        type="number" 
                                                        v-model.number="row.group_number" 
                                                        min="1"
                                                        class="form-control" 
                                                        :placeholder="$t('form.student.groupNumber')"
                                                        @blur="sortPaymentSummaryItemsByGroup"
                                                    />
                                                </td>
                                                <td class="text-center align-middle">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === 0" @click="moveRowUp(row)">↑</button>
                                                        <span class="mx-1">{{ row.sort_order || 1 }}</span>
                                                        <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === getGroupItems(row).length - 1" @click="moveRowDown(row)">↓</button>
                                                    </div>
                                                </td>
                                                
                                                <td class="text-right">
                                                    <button class="btn btn-danger btn btn-sm" @click="removeRow(idx)">
                                                    <span class="fa fa-trash"></span>
                                                    </button>
                                                
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="5">
                                                <strong>{{ $t("form.student.totalPaymentReceived") }} {{ paymentSummaryCurrency }} {{ paymentSummaryTotalAmountFormatted | curreny(decimalDigits, decimalPoint, thousandSeparator) }}</strong>
                                            </td>
                                            <td v-if="studentPaymentSummary.GroupByYear"></td>
                                            <td v-if="studentPaymentSummary.CustomGrouping"></td>
                                            <td class="text-right">
                                                <button class="btn btn-primary" @click="savePaymentSummary">{{ $t("form.student.savePaymentSummary") }}</button>
                                                <button class="btn btn-success" @click="addRow">
                                                    <span class="fa fa-plus"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div class="row mb-3 mt-3" v-if="studentPaymentSummary.GroupByYear && paymentSummaryItems.length">
                                <div class="form-group col-md-12">
                                    <h5>{{ $t("form.student.subtotalLabels") }}</h5>
                                    <div v-for="year in getUniqueYears()" :key="year" class="mb-3">
                                        <label>
                                            {{ $t("form.student.subtotalText") }} 
                                            <span v-if="year === 'noYear'">{{ $t('form.student.noYear') }}</span>
                                            <span v-else>{{ year }}</span>
                                        </label>
                                        <input 
                                            type="text" 
                                            v-model="subtotalLabelsInput[year]" 
                                            class="form-control" 
                                            :placeholder="getSubtotalPlaceholder(year, 'year')" 
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 mt-3" v-if="studentPaymentSummary.CustomGrouping && paymentSummaryItems.length">
                                <div class="form-group col-md-12">
                                    <h5>{{ $t("form.student.subtotalLabels") }}</h5>
                                    <div v-for="group in getUniqueGroups()" :key="group" class="mb-3">
                                        <label>
                                            {{ $t("form.student.subtotalText") }} 
                                            <span v-if="group === 'unspecified'">{{ $t('form.student.unspecifiedGroup') }}</span>
                                            <span v-else>{{ $t('form.student.group') }} {{ group }}</span>
                                        </label>
                                        <input 
                                            type="text" 
                                            v-model="subtotalLabelsInput[group]" 
                                            class="form-control" 
                                            :placeholder="getSubtotalPlaceholder(group, 'group')" 
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal>
              </b-tab>

              <b-tab :title="$t('form.student.tabTranscript')" v-if="showTranscriptTab">
                <transcript :dateFormat="dateFormat" v-if="grades.length" :id="student.ID"
                  :program_code="selectedProgramCode" :localGradeLabel="localGradeLabel" :gradingScales="gradingScales"
                  :showLocalGrades="showLocalGrades" :studentProgram="studentProgram"
                  :showSecondaryLocalGrades="showSecondaryLocalGrades"></transcript>
                <p v-else>
                  {{ $t("form.student.noTranscript") }}
                </p>
              </b-tab>

              <b-tab :title="$t('form.student.tabAudits')" v-if="showAuditTab">
                <div class="card-body table-responsive p-0">
                  <p class="p-3 m-0 text-center" v-if="loadingAudits">
                    <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#000">
                      <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                          <circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle>
                          <path d="M36 18c0-9.94-8.06-18-18-18">
                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18"
                              dur="0.8s" repeatCount="indefinite"></animateTransform>
                          </path>
                        </g>
                      </g>
                    </svg>
                    Loading audit log records...
                  </p>
                  <table class="table table-hover" v-else-if="audits.length">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                        <th>User Name</th>
                        <th>Timestamp</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(audit, index) in audits" :key="index">
                        <td>{{ audit.field }}</td>
                        <td>
                          <div v-if="Array.isArray(audit.old_value)">
                            <div v-for="(oldValue, index) in audit.old_value" :key="index">
                              <p v-if="oldValue.path">{{ oldValue.path }} - {{ oldValue.timestamp }}</p>
                              <p v-else>{{ oldValue | replaceString(['false', '"null"', undefined], '') }}</p>
                            </div>
                          </div>
                          <div v-else>
                            <p>{{ audit.old_value | replaceString(['false', '"null"', undefined], '') }}</p>
                          </div>
                        </td>
                        <td>
                          <div v-if="Array.isArray(audit.new_value)">
                            <div v-for="(newValue, index) in audit.new_value" :key="index">
                              <p v-if="newValue.path">{{ newValue.path }} - {{ newValue.timestamp }}</p>
                              <p v-else>{{ newValue | replaceString(['false', '"null"', undefined], '') }}</p>
                            </div>
                          </div>
                          <div v-else>
                            <p>{{ audit.new_value | replaceString(['false', '"null"', undefined], '') }}</p>
                          </div>
                        </td>
                        <td>{{ audit.user.name }}</td>
                        <td>{{ audit.created_at | formatDate(datetimeFormat) }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p class="p-3 m-0" v-else-if="audits.length === 0 && !loadingAudits">No audit log records found.</p>
                </div>
                <pagination v-if="pagination_audit.last_page > 1" :pagination="pagination_audit" :offset="5"
                  @paginate="paginateAudit"></pagination>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="uncheck_graduate_modal_alumni" title="Update Status" hide-footer :no-enforce-focus="true">
      <div class="row">
        <div class="form-group col-12">
          <label for="StatusID:">{{ $t("form.student.status") }}</label>
          <v-select label="StatusName" @input="onChangeStatusModal" :options="statusList" v-model="status"
            :reduce="(statusList) => statusList">
          </v-select>
        </div>
        <div class="form-group col-12" v-if="statusCreateModeModal">
          <label for="StudentStatusComment:">{{
            $t("form.student.studentStatusComment")
          }}</label>
          <input type="text" name="StudentStatusComment" v-model="status.StatusComment" class="form-control" />
        </div>
        <div class="form-group col-12" v-if="statusCreateModeModal">
          <label for="StudentStatusDate:">{{
            $t("form.student.studentStatusDate")
          }}</label>

          <date-picker :lang="lang" class="date-picker" name="StudentStatusDate" v-model="datetomodel"
            valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
          </date-picker>
        </div>
        <div class="form-group col-6">
          <label for="StudentdPermitExpiryDate">{{
            $t("form.student.permitExpiryDate")
          }}</label>
          <date-picker class="date-picker" :lang="lang" :disabled="!permissions.editStudentsPersonalinformation"
            v-model="student.PermitExpiry" :editable="false" valueType="format" :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
          </date-picker>


        </div>

        <div class="form-group col-6">
          <label for="StudentPermitExpiryDate">{{
            $t("form.student.passportExpiryDate")
          }}</label>

          <date-picker class="date-picker" :lang="lang" :disabled="!permissions.editStudentsPersonalinformation"
            v-model="student.PassportExpiry" :editable="false" valueType="format" :format="dateFormat"
            :popup-style="{ top: '100%', left: 0 }" :append-to-body="false">
          </date-picker>
        </div>
        <div class="col-12" v-if="statusCreateModeModal">
          <button type="button" @click="addStatus($event)" class="btn btn-primary btn-block" name="modalupdate"
            :disabled="!status.StatusID || readonly">
            {{ $t("button.updateStatus") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import Transcript from "../../components/Transcript";
import applicationFile from "./../student/ApplicationFile";
import Summernote from "../../components/Summernote";
import Attachments from "./components/Attachments";
import GradingScaleResolver from "../../services/GradingScaleResolver";

/**
 * Vuelidate items
 */
import {
  required,
  minLength,
  maxLength,
  between,
  alpha,
  numeric,
  decimal,
  email,
} from "vuelidate/lib/validators";

export default {
  name: "alumni-edit",
  props: [
    "permissions",
    "editFormInterval",
    "dateFormat",
    "datetimeFormat",
    "decimalDigits",
    "decimalPoint",
    "thousandSeparator",
    "user",
    "fullPaymentDiscount",
  ],

  components: {
    vueDropzone: vue2Dropzone,
    Transcript,
    applicationFile,
    Summernote,
    Attachments,
  },

  data() {
    return {
      subtotalLabelsInput: {},
      request_source: '',
      options: [],
      linkedStudents: [],
      studentName: '',
      foundationAllowedCodes: [],
      foundationGrades: false,
      foundationProgram: {},
      program1Type: "",
      program2Type: "",
      coursesArr: [],
      courses2Arr: [],
      hovering: false,
      isInvalidDate: '', isInvalidDate2: '',
      gradingScales: [],
      defaultGradingScaleTypeId: null,
      localGradeLabel: "",
      showLocalGrades: false,
      showSecondaryLocalGrades: false,

      isLoading: true,
      fullPage: true,

      studentProgram2Title: "",

      checkInvoiceCall: true,

      graduatecheckbox: 0,
      graduatecheckboxchanged: 0,
      statusCreateModeModal: false,

      reduction_types: [],
      student_reduction: "",

      programchanged: 0,
      shouldnotclose: 0,

      tabIndex: 0,
      summary_tab: 11,

      alert: false,
      alertClass: "",
      alertMessage: "",

      disableEditFormMessage: "",
      disableEditForm: false,

      showDisableAlert: false,
      firstLoad: true,
      loadingAudits: false,
      sessionCreated: true,
      continueInterVal: true,

      requestSource: "",
      interval: "",
      invalidStudentCountry: false,
      image: "/images/student.jpg",
      partnersDisabled: false,
      isAccountingUser: false,
      invoiceType: "",
      programCodesSecondaryMajor: [],
      closing: true,
      gpa: null,
      fpGpa: null,
      localGpa: null,
      fpLocalGpa: null,

      gradeDetails: {
        CourseID: null,
        CourseTitle: null,
        DescriptiveGrade: null,
        ECTSGrade: null,
        Enrolled: null,
        FinalExameDate: null,
        FullTitle: null,
        Grade: null,
        ImportFlag: null,
        ImportUser: null,
        Percentage: null,
        StudentID: null,
      },
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      pagination: {
        current_page: 1,
      },

      pagination_audit: {
        current_page: 1,
      },

      // audits custom pagination
      currentPage: 1,
      perPageAudits: 5,
      fields: ["field", "oldValue", "newValue", "userName", "updatedAt"],

      thesisEvaluationDropzone: {
        url: "/api/students/thesis-evaluation",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        maxFiles: 1,
      },

      attachmentDropzone: {
        language: {
          dictDefaultMessage:
            "Drop a PDF file here, or click to select a file to upload.",
        },
        url: "/api/students/attachments",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        params: {
          student: localStorage.getItem("get-student")// Replace 123 with the actual student number value
        }
      },

      profileDropzone: {
        url: "/api/students/profile-image",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: true,
        maxFiles: 1,
      },

      applicationDropzone: {
        url: "/api/students/application",
        headers: {
          "X-CSRF-TOKEN":
            document.head.querySelector("[name=csrf-token]").content,
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
      },

      status: {
        StatusID: "",
        StatusName: "",
        StatusComment: "",
        StatusDate: this.formatDate(),
      },
      datetomodel: this.formatDate(),
      searchCourse: "",
      searchCourse2: "",
      selectedProgramCode: "",
      selectedProgram2Code: "",
      userPartnerCode: "",

      courses: [],
      fpCourses: [],
      courses2: [],
      countries: [],
      programs: [],
      secondaryPrograms: [],
      professor: [],
      grades: [],
      fpGrades: [],
      secondaryGrades: [],
      attachments: [],
      studentStatus: [],
      statusList: [],
      partners: [],
      partnercampus: [],
      audits: [],
      updatedAudits: [],
      studentAbsences: [],
      studentInvoices: [],
      paymentPlans: [],

      titles: [],
      descriptiveGrades: [],
      ECTSGrades: [],
      gradeType: "pr",

      student: {
        ID: 0,
        StudentNumber: null,
        FirstName: "",
        LastName: "",
        TranscriptName: null,
        Title: null,
        BirthDate: null,
        PermitExpiry: null,
        PassportExpiry: null,
        BirthPlace: null,
        BirthCountry: null,
        Nationality: null,
        StreetAddress: null,
        City: null,
        Zip: null,
        Country: null,
        Phone: null,
        Mobile: null,
        Fax: null,
        Email: null,
        Email2: null,
        Email3: null,
        WebAddress: null,
        Photo: null,
        Remarks: null,
        Notes: null,
        MailAddress: 1,
        Student: 1,
        Professor: 1,
        Staff: 1,
        SISEnabled: 0,
        GradeNotification: 0,
        BirthdayNotification: 1,
        PartnerID: null,
        PartnerCampusID: null,
        ImportFlag: 1,
        ImportUser: 1,
        CurrentStatus: 0,
        LegalizationRequired: 0,
        GlobalDiscount: 0,
        FullPaymentDiscount: this.defaultFullPaymentDiscount,
        ProgramStart: null
      },

      studentProgram: {
        ProgramID: null,
        Program2ID: null,
        FoundationID: null,
        BooksIncluded: null,
        Graduate: null,
        Withdraw: null,
        GraduationDate: this.formatDate(),
        ThesisPercentage: null,
        ThesisDescriptiveGrade: null,
        ThesisGrade: null,
        ThesisECTSGrade: null,
        ThesisSubject: null,
        ThesisMentor: null,
        ThesisEvaluation: null,
        ProgramCode: null,
        Examiner1: null,
        Examiner2: null,
        Examiner3: null,
        Examiner4: null,
        Examiner5: null,
      },

      studentGraduateReq: {
        BBAExitSurvey: null,
        BBAExitSurveyCBE: null,

        MASExitSurvey: null,
        MASExitExamSBS: null,
        MASExitExamSBSResult: null,
        MASExitExamExternal: null,
        MASExitExamExternalResult: null,
        MSCInternReport: null,

        DBAExitSurvey: null,
        DBAExitExamSBS: null,
        DBAExitExamSBSResult: null,
        DBAExitExamExternal: null,
        DBAExitExamExternalResult: null,

        DBAEthicsApprovalDoc: null,
        DBAEApprovalDate: null,
        DBAStatsExamDate: null,
        DBAStatsExamResult: null,
        DBACompsDate: null,
        DBACompsResult: null,
        DBAMAIssued: null,
        DBAMADate: null,
        DBADissertation: null,
        DBADODDate: null,
        DBADegreeIssued: null,
        DBADegreeIssueDate: null,

        FinancialObligations: null,
        PassingGPA: null,
      },

      studentBussiness: {
        CompanyName: null,
        Department: null,
        Position: null,
        StreetAddress: null,
        City: null,
        Zip: null,
        Country: null,
        Phone: null,
        Mobile: null,
        Fax: null,
        Email: null,
        WebAddress: null,
        ContactPersonTitle: null,
        ContactPersonFirstName: null,
        ContactPersonLastName: null,
        ContactPersonDepartment: null,
        Notes: null,
        StudentID: null,
        ProfessorID: null,
      },

      studentAdmission: {
        EducationalBackground: null,
        SBSTest: null,
        GMATTest: null,
        GMATResult: null,
        SATTest: null,
        SATResult: null,
        TOEFLTest: null,
        TOEFLResult: null,
        IELTSTest: null,
        IELTSResult: null,
        ExamAdmBBA: null,
        ExamAdmResultBBA: null,
        ExamEntBBA: null,
        ExamEntResultBBA: null,
        ExamOthBBA: null,
        ExamOthResultBBA: null,
        ExamAdmMAS: null,
        ExamAdmResultMAS: null,
        ExamEntMAS: null,
        ExamEntResultMAS: null,
        ExamOthMAS: null,
        ExamOthResultMAS: null,
        ExamEntDBA: null,
        ExamEntResultDBA: null,
        ExamOthDBA: null,
        ExamOthResultDBA: null,
      },

      studentFinance: {
        GlobalDiscount: null,
        FullPaymentDiscount: null,
      },

      studentPaymentSummary: {
        DateFrom: '',
        DateTo: '',
        SummaryDate: this.toDayDate(),
        TitleText: `Payment Confirmation ${new Date().getFullYear()}`,
        IntroText: '',
        Currency: 'CHF',
        ClosingText: 'Feel free to contact us should you have any questions.',
        DefaultStatus: 'Pending',
        GroupByYear: false,
        CustomGrouping: false,
        GrandTotalLabel: 'Total fees paid to date:'
      },
      currencies: [],
      paymentSummaries: [],
      paymentSummaryItems: [],

      studentAbsence: {
        Date: null,
        Reason: null,
        CourseID: null,
        CourseTitle: null,
        Remarks: null,
      },

      studentApplication: {
        CurriculumVitae: [],
        Degree: [],
        Transcript: [],
        Letter: [],
        Picture: [],
        PassportCopy: [],
        PermitCopy: [],
        AdditionalDocuments: [],
        Score: "",
        EnglishProficiency: [],
        ResearchInterestOutline: [],
        AssociateDegree: [],
        ValidPassportCopy: false,
        ValidPermitCopy: false,
        ValidAssociateDegree: false,
        ValidResearchInterestOutline: false,
        ValidCurriculumVitae: false,
        ValidDegree: false,
        ValidTranscript: false,
        ValidLetter: false,
        ValidPicture: false,
        ValidEnglishProficiency: false,
      },
    };
  },

  validations: {
    student: {
      FirstName: {
        required,
        maxLength: maxLength(100),
      },
      LastName: {
        required,
        maxLength: maxLength(100),
      },
      BirthPlace: {

        maxLength: maxLength(100),
      },
      Email: {
        required,
        email,
      },
      MatriculationNum: {
        maxLength: maxLength(20),
      },
    },

    studentProgram: {
      ThesisSubject: {
        maxLength: maxLength(255),
      },
      ThesisPercentage: {
        numeric,
        maxLength: maxLength(10),
      },
    },

    grades: {
      $each: {
        Percentage: {
          between: between(0, 100),
        },
        Grade: {
          between: between(0, 4),
        },
        LocalGrade: {
          between: between(0, 6),
        },
      },
    },

    fpGrades: {
      $each: {
        Percentage: {
          between: between(0, 100),
        },
        Grade: {
          between: between(0, 4),
        },
        LocalGrade: {
          between: between(0, 6),
        },
      },
    },

    secondaryGrades: {
      $each: {
        Percentage: {
          between: between(0, 100),
        },
        Grade: {
          between: between(0, 4),
        },
        LocalGrade: {
          between: between(0, 6),
        },
      },
    },
    studentFinance: {
      GlobalDiscount: {
        decimal,
        maxLength: maxLength(10),
        between: between(0, 100),
      },
      FullPaymentDiscount: {
        decimal,
        maxLength: maxLength(10),
        between: between(0, 100),
      },
    },
  },

  computed: {
    paymentSummaryTotalAmount() {
      return this.paymentSummaryItems.reduce((s, it) => s + (parseFloat(it.amount_received) || 0), 0);
    },
    paymentSummaryTotalAmountFormatted() {
      return this.paymentSummaryTotalAmount.toFixed(2);
    },
    paymentSummaryCurrency() {
      if (this.paymentSummaryItems.length > 0) {
        return this.paymentSummaryItems[0].currency ?? '';
      }
      return '';
    },
    defaultFullPaymentDiscount() {
      return this.fullPaymentDiscount;
    },

    totalAudits() {
      return this.audits.length;
    },

    readonly() {
      return !this.permissions.editAlumni;
    },

    cardTitle() {
      return `${this.student.FirstName} ${this.student.LastName} - ${this.student.StudentNumber}`;
    },

    isPartnerSchoolUser() {
      if (this.user.roles) {
        let found = this.user.roles.find(
          (role) => role.slug == "partner.school"
        );

        if (found) return true;
      }

      return false;
    },

    isFrontOfficeUser() {
      if (this.user.roles) {
        let found = this.user.roles.find((role) => role.slug == "front.office");

        if (found) return true;
      }

      return false;
    },

    isRecruitmentManagerUser() {
      if (this.user.roles) {
        let found = this.user.roles.find(
          (role) => role.slug == "recruitment.manager"
        );

        if (found) return true;
      }

      return false;
    },
    /* Other groups eligible to view finance tab*/
    groupsCanViewFinanceTab() {
      let res = false,
        role = null;
      const eligbleRoles = [
        "registrar",
        "management",
        "program.all",
        "program.bba",
        "program.mba",
        "program.msc",
        "program.dba",
      ];

      for (const roleSlug of eligbleRoles) {
        if (!role) {
          role = this.user.roles.find((role) => role.slug == roleSlug);
        } else {
          if (role) {
            res = true;
          }
        }
      }

      return res;
    },
    showAbsencesTab() {
      return !(this.isFrontOfficeUser || this.isRecruitmentManagerUser);
    },

    showApplicationTab() {
      return !(this.isFrontOfficeUser || this.isRecruitmentManagerUser);
    },

    showFinanceTab() {
      if (this.isFrontOfficeUser || this.isRecruitmentManagerUser) {
        return false;
      }
      /* Please review the above check*/
      if (
        (!this.isPartnerSchoolUser && this.isAccountingUser) ||
        this.groupsCanViewFinanceTab
      ) {
        return true;
      } else {
        return false;
      }
    },

    showPaymentSummaryTab() {
      if (this.isAccountingUser) {
          return true;
      } else {
          return false;
      }
    },

    showTranscriptTab() {
      return !(
        this.isFrontOfficeUser ||
        this.isRecruitmentManagerUser ||
        this.isPartnerSchoolUser
      );
    },

    showAuditTab() {
      if (this.isFrontOfficeUser || this.isRecruitmentManagerUser) return false;

      return !this.isPartnerSchoolUser;
    },
  },

  watch: {
    student: {
      handler(newStudent) {
        this.onChangePassportExpiryDate();
        this.onChangePermitExpiryDate();
        if (newStudent.ID != undefined && newStudent.ID && this.checkInvoiceCall) {
          this.getStudentInvoices();
        }
        if (newStudent && newStudent.ID) {
          this.fetchLinkedStudents();
        }
        this.closing = false;
      },
      deep: true,
    },
    tabIndex(value) {
      if (value == 12) {
        this.getAudits();
      }
    },

    studentBussiness: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    studentAdmission: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    studentProgram: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    grades: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    fpGrades: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    secondaryGrades: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    studentGraduateReq: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    attachments: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    studentAbsences: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    studentApplication: {
      handler(val) {
        this.closing = false;
      },
      deep: true,
    },

    "student.PartnerID": function (val) {
      this.checkLocalGrade();
      this.checkLocalGrade2();
    },

    "studentProgram.ProgramID": function (val) {
      this.checkLocalGrade();
    },

    "studentProgram.Program2ID": function (val) {
      this.checkLocalGrade2();
    },

    '$route.params.id': {
      immediate: false,
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.resetStudentData();
          this.getStudent();
        }
      }
    },

    'studentPaymentSummary.GroupByYear'(newValue) {
      if (newValue) {
        // 1. Clear custom grouping
        this.studentPaymentSummary.CustomGrouping = false;
        this.paymentSummaryItems.forEach(item => { item.group_number = null; });

        // 2. Populate years for existing items
        this.paymentSummaryItems.forEach((item, idx) => {
            if (item.payment_date && !item.year) {
                this.autoPopulateYear(item, idx);
            }
        });

        // 3. Sort and RESET sort_order to 1, 2, 3...
        this.sortPaymentSummaryItemsByYear();
        this.resortItems();
      }
    },

    'studentPaymentSummary.CustomGrouping'(newValue) {
      if (newValue) {
        // 1. Clear year grouping
        this.studentPaymentSummary.GroupByYear = false;
        this.paymentSummaryItems.forEach(item => { item.year = null; });

        // 2. Sort and RESET sort_order to 1, 2, 3...
        this.sortPaymentSummaryItemsByGroup();
        this.resortItems();
      }
    }
  },

  async mounted() {
    if (!this.permissions.viewAlumni) {
      return this.$router.push("/");
    }

    if (this.permissions.editAlumni) {
      this.checkForEdit();
      let self = this;

      this.interval = setInterval(() => {
        if (self.continueInterVal) self.checkForEdit();
      }, this.editFormInterval);
    }

    this.isLoading = true;
    await this.getInitialData();
    await this.getStudent();
    if (Number(localStorage.getItem("summary-tab")) === this.summary_tab) {                       
      this.tabIndex = this.summary_tab;
      localStorage.removeItem("summary-tab");
    }
    if (this.permissions.viewSettingsReductiontypes) {
      await this.getReductionTypes();
    }
    this.closing = true;
  },

  methods: {
    addRow() {
      this.paymentSummaryItems.push({ invoice_id: null, invoice_number: '', amount_received: 0, payment_date: null, is_manual: true, sort_order: this.paymentSummaryItems.length + 1 });
    },
    removeRow(i) {
      this.paymentSummaryItems.splice(i, 1);
    },
    getGroupKey(item) {
      if (!item) return null; // Handle undefined
      const isYear = this.summary?.group_by_year || this.studentPaymentSummary?.GroupByYear;
      const isCustom = this.summary?.custom_grouping || this.studentPaymentSummary?.CustomGrouping;
      if (isYear) return item.year || 'no_year';
      if (isCustom) return item.group_number?.toString() || 'unspecified';
      return null;
    },

    getGroupItems(item) {
      const key = this.getGroupKey(item);
      if (!key) return this.paymentSummaryItems;
      return this.paymentSummaryItems.filter(i => this.getGroupKey(i) === key);
    },

    moveRowUp(item) {
      const group = this.getGroupItems(item);
      const idx = group.indexOf(item);
      if (idx > 0) {
        const prev = group[idx - 1];
        // Swap sort_order
        const temp = item.sort_order || 0;
        this.$set(item, 'sort_order', prev.sort_order || 0);
        this.$set(prev, 'sort_order', temp);
        // Re-sort and re-index
        this.resortItems();
      }
    },

    moveRowDown(item) {
      const group = this.getGroupItems(item);
      const idx = group.indexOf(item);
      if (idx < group.length - 1) {
        const next = group[idx + 1];
        // Swap sort_order
        const temp = item.sort_order || 0;
        this.$set(item, 'sort_order', next.sort_order || 0);
        this.$set(next, 'sort_order', temp);
        // Re-sort and re-index
        this.resortItems();
      }
    },

    resortItems() {
      const isYear = this.studentPaymentSummary?.GroupByYear;
      const isCustom = this.studentPaymentSummary?.CustomGrouping;

      // 1. Sort the array
      this.paymentSummaryItems.sort((a, b) => {
        const keyA = this.getGroupKey(a);
        const keyB = this.getGroupKey(b);
        
        // If not grouped, just sort by sort_order
        if (!isYear && !isCustom) {
          return (a.sort_order || 0) - (b.sort_order || 0);
        }

        // Sort by group first
        if (keyA !== keyB) {
          if (keyA === 'unspecified' || keyA === 'no_year') return 1;
          if (keyB === 'unspecified' || keyB === 'no_year') return -1;
          return keyA - keyB;
        }
        // Then by sort_order
        return (a.sort_order || 0) - (b.sort_order || 0);
      });

      // 2. Re-index sort_order to be sequential (1, 2, 3...) within groups
      // We must track the current group to reset the counter
      let currentGroup = null;
      let counter = 1;

      this.paymentSummaryItems.forEach(item => {
        const itemGroup = this.getGroupKey(item);
        
        if (itemGroup !== currentGroup) {
          currentGroup = itemGroup;
          counter = 1; // Reset counter for new group
        }
        
        this.$set(item, 'sort_order', counter);
        counter++;
      });
    },

    // Drag & Drop Handlers
    onDragStart(event, item) {
      event.dataTransfer.setData('text/plain', item.invoice_number || item.amount_received);
      this.draggingItem = item;
      event.target.style.opacity = '0.5';
    },

    onDragOver(event) {
      event.preventDefault();
    },

    onDrop(event, targetItem) {
      event.preventDefault();
      if (!this.draggingItem || this.draggingItem === targetItem) return;

      // Restrict drag & drop to same group
      if (this.getGroupKey(this.draggingItem) !== this.getGroupKey(targetItem)) {
          return;
      }

      // Swap sort_order values
      const temp = this.draggingItem.sort_order || 0;
      this.$set(this.draggingItem, 'sort_order', targetItem.sort_order || 0);
      this.$set(targetItem, 'sort_order', temp);

      // Re-sort and re-index everything to ensure clean 1,2,3 sequence
      this.resortItems();
      
      this.draggingItem = null;
      document.querySelectorAll('.draggable-row').forEach(el => el.style.opacity = '1');
    },
    async getPaymentData() {
      this.loading = true;

      await axios
      .get(`/api/students/${this.student.ID}/payment-data`, {
        params: {
          from: this.studentPaymentSummary.DateFrom || null,
          to: this.studentPaymentSummary.DateTo || null
        }
      })
      .then(response => {
          this.paymentSummaryItems = [];

          if (response.data.length === 0) {
            alert(this.$t('No invoices found.'));
            return;
          }

          response.data.forEach((f, index) => {
            if (
              f.invoice_id &&
              !this.paymentSummaryItems.some(it => it.invoice_id === f.invoice_id)
            ) {
            // Extract year from payment_date if it exists
            let year = null;
            if (f.payment_date) {
              const momentDate = moment(f.payment_date);
              if (momentDate.isValid()) {
                year = momentDate.format('YYYY');
              }
            }
            this.paymentSummaryItems.push({
              invoice_id: f.invoice_id,
              invoice_number: f.invoice_number,
              amount_received: f.amount_received,
              payment_date: f.payment_date && moment(f.payment_date).isValid() ? moment(f.payment_date).format(this.dateFormat) : null,
              currency: f.currency,
              is_manual: false,
              year: year,
              sort_order: index + 1
            });

            // Sort items by year (years ascending, null/empty years at end)
            if (this.studentPaymentSummary.GroupByYear) {
              this.sortPaymentSummaryItemsByYear();
            }
          }
        });
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    savePaymentSummary() {
      const payload = {
        student_id: this.student.ID,
        summary_date: this.studentPaymentSummary.SummaryDate,
        currency: this.studentPaymentSummary.Currency,
        title: this.studentPaymentSummary.TitleText,
        intro_text: this.studentPaymentSummary.IntroText,
        closing_text: this.studentPaymentSummary.ClosingText,
        status: this.studentPaymentSummary.DefaultStatus,
        group_by_year: this.studentPaymentSummary.GroupByYear || false,
        custom_grouping: this.studentPaymentSummary.CustomGrouping || false,
        grand_total_label: this.studentPaymentSummary.GrandTotalLabel || this.$t('form.student.totalFeesPaidToDate'),
        subtotal_labels: this.subtotalLabelsInput,
        paymentSummaryItems: this.paymentSummaryItems.map(i => ({
          invoice_id: i.invoice_id,
          invoice_number: i.invoice_number,
          amount_received: i.amount_received,
          payment_date: i.payment_date,
          is_manual: i.is_manual,
          year: i.year || null,
          group_number: i.group_number || null,
          sort_order: i.sort_order || 0
        }))
      };

      this.isLoading = true;

      axios
      .post('/api/payment-summaries', payload)
      .then((response) => {
        this.isLoading = false;
        this.showAlert(response.data.message);
        this.getStudentPaymentSummaries();
        this.paymentSummaryItems = [];
        this.subtotalLabelsInput = {};
        this.studentPaymentSummary.DateFrom = '';
        this.studentPaymentSummary.DateTo = '';
        this.studentPaymentSummary.GroupByYear = false;
        this.studentPaymentSummary.CustomGrouping = false;
        this.studentPaymentSummary.GrandTotalLabel = '';
        this.$refs.paymentSummaryModal.hide();
      })
      .catch((error) => {
        this.isLoading = false;

        if (error.response.data.error) {
          this.showAlert(error.response.data.message, "danger");
        }
      });
    },
    /**
    * Get Student Payment Summaries
    */
    getStudentPaymentSummaries() {
      axios
      .get(`/api/payment-summaries/student/${this.student.ID}`)
      .then(res => {
          this.paymentSummaries = res.data;
      })
      .catch(err => {
          console.error(err);
      });
    },
    /**
    * Go to Show Summary Page
    */
    goToShowSummary(id) {
      localStorage.setItem("summary-tab", 11);
      this.$router.push({
        name: "PaymentSummaryShow",
        params: {
          id: id
        },
        query: {
          origin: 'alumni'
        }
      });
    },
    /**
     * Go to Summary edit page
     */
    goToEditSummary(id) {
      localStorage.setItem("summary-tab", 11);
      this.$router.push({
        name: 'PaymentSummaryEdit',
        params: {
          id: id
        },
        query: {
          origin: 'alumni'
        }
      });
    },
    /**
     * Delete student Payment Summary
     */
    deleteSummary(sps) {

      var id = sps.id;

      if(sps.status == 'Sent'){
        var conf = confirm(this.$t('form.validation.deleteSentPaymentSummary'));
      } else {
        var conf = confirm(this.$t('form.validation.delete'));
      }

      if (conf === true) {
        this.isLoading = true;
        axios
        .delete(`/api/payment-summaries/${id}`)
        .then(response => {
          this.isLoading = false;
          const rowIndex = this.paymentSummaries.findIndex(item => item.id === id);
          if (rowIndex !== -1) {
            this.paymentSummaries.splice(rowIndex, 1);
          }
          this.showAlert(response.data.message);
          this.getStudentPaymentSummaries();
        })
        .catch(error => {
          if (error.response) {
            this.isLoading = false;
            this.showAlert(error.response.data.message, 'danger');
          } else {
            this.isLoading = false;
            this.showAlert(error, 'danger');
          }
        });
      }
    },
    handleGroupByYearChange() {
      if (this.studentPaymentSummary.GroupByYear) {
        this.studentPaymentSummary.CustomGrouping = false;
        // Clear group numbers when switching to year grouping
        this.paymentSummaryItems.forEach(item => {
          item.group_number = null;
        });
      }
    },

    handleCustomGroupingChange() {
      if (this.studentPaymentSummary.CustomGrouping) {
        this.studentPaymentSummary.GroupByYear = false;
        // Clear years when switching to custom grouping
        this.paymentSummaryItems.forEach(item => {
          item.year = null;
        });
      }
    },

    autoPopulateYearOrGroup(row, idx) {
      if (this.studentPaymentSummary.GroupByYear) {
        this.autoPopulateYear(row, idx);
      }
      // For custom grouping, no auto-population needed
    },

    sortPaymentSummaryItemsByGroup() {
      if (!this.studentPaymentSummary.CustomGrouping) {
        return;
      }

      this.paymentSummaryItems.sort((a, b) => {
        const groupA = a.group_number !== null && a.group_number !== undefined && a.group_number !== '' ? parseInt(a.group_number) : null;
        const groupB = b.group_number !== null && b.group_number !== undefined && b.group_number !== '' ? parseInt(b.group_number) : null;

        // If both have group numbers, sort ascending
        if (groupA !== null && groupB !== null) {
          return groupA - groupB;
        }

        // If only A has group number, A comes first
        if (groupA !== null && groupB === null) {
          return -1;
        }

        // If only B has group number, B comes first
        if (groupA === null && groupB !== null) {
          return 1;
        }

        // If neither has group number, maintain original order
        return 0;
      });

      // Re-index sort_order numbers (1, 2, 3...) after sorting
      this.resortItems();
    },

    getUniqueGroups() {
      const groups = new Set();
      let hasUnspecified = false;

      this.paymentSummaryItems.forEach(item => {
        if (item.group_number !== null && item.group_number !== undefined && item.group_number !== '') {
          groups.add(item.group_number);
        } else {
          hasUnspecified = true;
        }
      });

      // Sort groups ascending and add 'unspecified' at the end
      const result = Array.from(groups).sort((a, b) => a - b);
      if (hasUnspecified) {
        result.push('unspecified');
      }

      return result;
    },

    sortPaymentSummaryItemsByYear() {
      if (!this.studentPaymentSummary.GroupByYear) {
        return;
      }

      this.paymentSummaryItems.sort((a, b) => {
        const yearA = a.year && a.year.trim() !== '' ? a.year : null;
        const yearB = b.year && b.year.trim() !== '' ? b.year : null;

        // If both have years, sort ascending
        if (yearA && yearB) {
          return yearA.localeCompare(yearB);
        }

        // If only A has year, A comes first
        if (yearA && !yearB) {
          return -1;
        }

        // If only B has year, B comes first
        if (!yearA && yearB) {
          return 1;
        }

        // If neither has year, maintain original order
        return 0;
      });

      // Re-index sort_order numbers (1, 2, 3...) after sorting
      this.resortItems();
    },

    autoPopulateYear(row, idx) {
      if (!this.studentPaymentSummary.GroupByYear) {
        return;
      }

      if (row.payment_date) {
        let year = '';

        // Handle different date formats
        if (typeof row.payment_date === 'string') {
          // If it's a string like "03.05.2024" (DD.MM.YYYY)
          const parts = row.payment_date.split('.');
          if (parts.length === 3) {
            year = parts[2]; // Get year from DD.MM.YYYY
          } else {
            // Try moment parsing
            const momentDate = moment(row.payment_date, this.dateFormat);
            if (momentDate.isValid()) {
              year = momentDate.format('YYYY');
            }
          }
        } else if (row.payment_date instanceof Date) {
            year = row.payment_date.getFullYear().toString();
        } else {
          // Try moment parsing as fallback
          const momentDate = moment(row.payment_date);
          if (momentDate.isValid()) {
            year = momentDate.format('YYYY');
          }
        }

        if (year && year.length === 4 && !isNaN(year)) {
          this.$set(this.paymentSummaryItems[idx], 'year', year);
          
          // Re-sort after year is populated
          this.sortPaymentSummaryItemsByYear();
        }
      }
    },

    getUniqueYears() {
      const years = new Set();
      let hasNoYear = false;

      this.paymentSummaryItems.forEach(item => {
        if (item.year && item.year.trim() !== '' && item.year.length === 4) {
          years.add(item.year);
        } else {
          hasNoYear = true;
        }
      });

      // Sort years ascending and add 'noYear' at the end
      const result = Array.from(years).sort((a, b) => a.localeCompare(b));
      if (hasNoYear) {
        result.push('noYear');
      }

      return result;
    },

    getSubtotalPlaceholder(value, type) {
      if (type === 'year') {
        if (value === 'noYear') {
          return this.$t('form.student.totalFeesPaid');
        }
        return this.$t('form.student.totalFeesForYear', {year: value});
      } else if (type === 'group') {
        if (value === 'unspecified') {
          return this.$t('form.student.totalFeesPaid');
        }
        return this.$t('form.student.totalFeesForGroup', {group: value});
      }
      return this.$t('form.student.totalFeesPaid');
    },

    resetStudentData() {
      this.grades = [];
      this.coursesArr = [];
      this.courses2Arr = [];
      this.fpGrades = [];
      this.secondaryGrades = [];
      this.attachments = [];
      this.studentAbsences = {};
      this.studentStatus = [];
      this.studentInvoices = [];
      this.status = {StatusID: "", StatusName: "", StatusComment: "", StatusDate: this.toDayDate()};
      this.image = "/images/student.jpg";
    },
    async fetchLinkedStudents() {
      await axios.get(`/api/students/${this.student.ID}/links`).then(res => {
        this.linkedStudents = res.data;
      });
    },
    async addLink(student) {
      await axios.post(`/api/students/${this.student.ID}/links`, {
        linked_student_id: student.ID,
      }).then(() => {
        this.selected = null;
        this.clear();
        this.fetchLinkedStudents();
      });
    },
    async removeLink(linkedId) {
      await axios.post(`/api/students/${this.student.ID}/links/remove`, {
        linked_student_id: linkedId,
      }).then(() => {
        this.fetchLinkedStudents();
      });
    },

    /**
     * Search students
     */
    async searchStudent() {
      if (this.studentName == '') {
        this.clear();
        return;
      }

      let source = axios.CancelToken.source();

      if (this.request_source != '')
          this.request_source.cancel('Operation canceled by the user.');

      this.request_source = source;

      axios
          .get(`/api/alumni?nameOrNumber=${this.studentName}`)
          .then(resp => this.options = resp.data.data.data)
          .catch(error => {console.log(error)});
    },

    clear() {
        this.options = [];
        this.studentName = '';
    },

    /**
     * Go to alumni edit page or student edit page
     */
    async editAlumni(studentNumber) {
      if (!this.permissions.viewAlumni) return;
      let res = await axios.get(`/api/alumni/${studentNumber}/find`);
      if (res.data.exists) {
          this.$router.push({
            name: "AlumniEdit",
            params: {
              id: studentNumber,
            },
          });
      } else {
        this.$router.push({
          name: "StudentEdit",
          params: {
            id: studentNumber,
          },
        });
      }
    },

    // Return ECTS Credits of primary program
    getECTSCreditsProgram1(fullTitle) {
      const course = this.coursesArr.find(course => fullTitle.includes(course.CourseCode));
      return course ? course.ECTSCredits : null;
    },

    // Return ECTS Credits of Foundation program
    getECTSCreditsFoundationProgram(fullTitle) {
      if (this.fpCourses) {
        const fpCourse = this.fpCourses.find(fpCourse => fullTitle.includes(fpCourse.CourseCode));
        return fpCourse ? fpCourse.ECTSCredits : null;
      }
    },

    // Return SBS Credits of primary program
    getSBSCreditsProgram1(fullTitle) {
      const course = this.coursesArr.find(course => fullTitle.includes(course.CourseCode));
      return course ? course.SBSCredits : null;
    },

    // Return SBS Credits of Foundation program
    getSBSCreditsFoundationProgram(fullTitle) {
      if (this.fpCourses) {
        const fpCourse = this.fpCourses.find(fpCourse => fullTitle.includes(fpCourse.CourseCode));
        return fpCourse ? fpCourse.SBSCredits : null;
      }
    },

    // Return ECTS Credits of secondary program
    getECTSCreditsProgram2(fullTitle) {
      const course = this.courses2Arr.find(course => fullTitle.includes(course.CourseCode));
      return course ? course.ECTSCredits : null;
    },

    // Return SBS Credits of secondary program
    getSBSCreditsProgram2(fullTitle) {
      const course = this.courses2Arr.find(course => fullTitle.includes(course.CourseCode));
      return course ? course.SBSCredits : null;
    },

    // Calculate the total credits based on the primary program type
    calculateTotalCredits1() {
      let total = 0;

      this.grades.forEach((grade) => {
        if (this.selectedProgramCode === 'DBA' || this.program1Type === 'CAP Program') {
          // Add SBS credits
          total += this.getSBSCreditsProgram1(grade.FullTitle);
        } else {
          // Add ECTS credits
          total += this.getECTSCreditsProgram1(grade.FullTitle);
        }
      });

      return total;
    },

    // Calculate the total credits based on the foundation program type
    calculateTotalCreditsFP() {
      let total = 0;

      if (this.fpGrades) {
        this.fpGrades.forEach((fpGrade) => {
          if (this.foundationProgram.ProgramCode === 'DBA' || this.foundationProgram.ProgramType === 'CAP Program') {
            // Add SBS credits
            total += this.getSBSCreditsFoundationProgram(fpGrade.FullTitle);
          } else {
            // Add ECTS credits
            total += this.getECTSCreditsFoundationProgram(fpGrade.FullTitle);
          }
        });
      }

      return total;
    },

    // Calculate the total credits based on the secondary program type
    calculateTotalCredits2() {
      let total = 0;

      this.secondaryGrades.forEach((grade) => {
        if (this.selectedProgram2Code === 'DBA' || this.program2Type === 'CAP Program') {
          // Add SBS credits
          total += this.getSBSCreditsProgram2(grade.FullTitle);
        } else {
          // Add ECTS credits
          total += this.getECTSCreditsProgram2(grade.FullTitle);
        }
      });

      return total;
    },

    showSelectedImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.image = URL.createObjectURL(file);
      }
    },
    replaceImage() {
      if (this.image) {
        const confirmed = confirm("Do you really want to replace the existing picture?");
        if (confirmed) {
          this.$refs.profile_image.click();
        }
      }
    },
    confirmDelete() {
      const confirmed = confirm("Do you really want to remove the existing picture?");

      if (confirmed) {
        const attach = { student_number: this.student.StudentNumber };
        axios
          .post("/api/deleteProfileImage", attach)
          .then(response => {
            if (response.data.error) {
              this.showAlert(response.data.message, "warning");
            } else if (response.data.success) {
              this.getStudent();
              this.image = "/images/student.jpg";
              this.showAlert(response.data.message, "success");
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 403) {
              this.showAlert(error.response.data.message, "warning");
            } else {
              console.log("error", error);
            }
          });
      }
    },

    onChangePassportExpiryDate() {

      let value = this.student.PassportExpiry;
      if (!value) {
        return this.isInvalidDate = "";
      }

      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");
      // Get current date as moment object
      const currentDate = moment();
      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");
      if (diffInMonths <= 1) {
        return this.isInvalidDate = "is-invalid";
      }
      return this.isInvalidDate = "";
    },
    onChangePermitExpiryDate() {

      let value = this.student.PermitExpiry;
      if (!value) {
        // Value is not set, change style;
        return this.isInvalidDate2 = "";

      }
      // Convert input date string to moment object and format to "YYYY-MM-DD" format
      const inputDate = moment(value, "DD.MM.YYYY").format("YYYY-MM-DD");
      // Get current date as moment object
      const currentDate = moment();
      // Calculate the difference in months between the two dates
      const diffInMonths = moment(inputDate).diff(currentDate, "months");
      if (diffInMonths <= 1) {
        return this.isInvalidDate2 = "is-invalid";

      }
      return this.isInvalidDate2 = "";
    },

    programTypeId(programId) {
      if (!programId) return null;
      const p = (this.programs || []).find(p => p.ID === programId);
      return p && p.GradingScaleTypeID ? Number(p.GradingScaleTypeID) : null;
    },

    checkLocalGrade2() {
      const programID = this.studentProgram.Program2ID;
      const partnerID = this.student.PartnerID;
      if (!(programID && partnerID)) return;

      const currentProgramCode = this.programs.find(e => e.ID == programID).ProgramCode;
      const currentPartnerCode = this.partners.find(e => e.PartnerID == partnerID).PartnerCode;

      const localScale = GradingScaleResolver.resolveLocal(this.gradingScales, {
        programCode: currentProgramCode,
        partnerCode: currentPartnerCode,
        typeId: this.programTypeId(programID),
        defaultTypeId: this.defaultGradingScaleTypeId,
      });

      this.showSecondaryLocalGrades = !!localScale && !!localScale.local_grading_scale;
    },

    checkLocalGrade() {
      const programID = this.studentProgram.ProgramID;
      const partnerID = this.student.PartnerID;
      if (!(programID && partnerID)) return;

      const currentProgramCode = this.programs.find(e => e.ID == programID).ProgramCode;
      const currentPartnerCode = this.partners.find(e => e.PartnerID == partnerID).PartnerCode;

      const localScale = GradingScaleResolver.resolveLocal(this.gradingScales, {
        programCode: currentProgramCode,
        partnerCode: currentPartnerCode,
        typeId: this.programTypeId(programID),
        defaultTypeId: this.defaultGradingScaleTypeId,
      });

      if (localScale && localScale.local_grading_scale) this.localScale = localScale;
      if (localScale) this.localGradeLabel = localScale.local_grade_name;
      this.showLocalGrades = !!localScale && !!localScale.local_grading_scale;
    },

    sendingEvent(file, xhr, formData) {
      formData.append("StudentNumber", this.$route.params.id);
    },

    /**
     * Thesis evaluation form uploaded
     */
    thesisEvaluationUploaded(file, response) {
      this.isLoading = false;
      this.studentProgram.ThesisEvaluation = `${this.student.StudentNumber}/${response.id}/${response.filename}`;

      this.updateStudent();
    },

    async downloadThesisEvaluation(file, isDownload) {
      let token = await this.createToken("student-thesis");

      if (token == "") return;
      window.open(
        `/students/${this.student.ID}/thesis-evaluation?file=${file}&download=${isDownload}&token=${token}`,
        "_blank"
      );
    },

    /**
     * Delete individual Alumni status history entry
     */
    deleteStatusEntry(index) {
      let conf = confirm(this.$t("form.validation.deleteStatus"));

      if (conf === true) {
        this.isLoading = true;

        axios
          .delete(
            `/api/students/${this.student.ID}/studentstatus/${this.student?.status[index]?.pivot?.ID}`
          )
          .then((response) => {
            this.studentStatus.splice(index, 1);
            this.student.status.splice(index, 1);
            this.showAlert(response.data.message);
            this.isLoading = false;
          })
          .catch((error) => {
            this.showAlert(error.response.data.message, "danger");
            this.isLoading = false;
          });
      }
    },

    getAttachmentFileName(file) {
      var file = file;
      if (typeof file === "string") {
        return file.substring(file.lastIndexOf("/") + 1);
      } else {
        return file;
      }
    },
    /**
     * Go to Show Invoice Page
     */
    goToShow(id, version) {
      if (!this.permissions.viewInvoices) return;
      localStorage.setItem('from', "InvoiceShowV1");
      this.$router.push({
        name: version === "V1" ? "InvoiceShowV1" : "InvoiceShowV2",

        params: {
          id: id
        }
      });
    },

    /**
     * Go to Invoice edit page
     */
    goToEdit(id) {
      if (!this.permissions.editInvoicesStudents) return;
      localStorage.setItem('from', "BackButtonClicked");

      localStorage.setItem("finance-tab", this.student.ID);

      this.$router.push({
        name: "StudentInvoiceEdit",
        params: {
          id: id
        }
      });
    },
    /**
     * Delete student invoice
     */
    deleteInvoice(invoice) {
      if (!this.permissions.deleteInvoicesAlumni) {
        this.showAlert(this.$t("form.validation.cantDeleteInvoice"), "danger");
        return;
      }
      var index = invoice.ID;

      if (invoice.Status == 3) {
        var conf = confirm(this.$t("form.validation.deleteSentInvoice"));
      } else if (invoice.Status == 4) {
        var conf = confirm(this.$t("form.validation.deletePaidInvoice"));
      } else {
        var conf = confirm(this.$t("form.validation.delete"));
      }

      if (conf === true) {
        this.isLoading = true;
        axios
          .delete("/api/invoices/" + index)
          .then((response) => {
            this.isLoading = false;
            this.studentInvoices.splice(index, 1);
            this.showAlert(response.data.message);
            this.getStudentInvoices();
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              this.isLoading = false;
              this.showAlert(error.response.data.message, "danger");
            } else {
              this.isLoading = false;
              this.showAlert(error, "danger");
            }
          });
      }
    },
    async getStudentReductionType() {
      this.isLoading = true;

      try {
        const response = await axios.post("/api/reduction-types/student", {
          student: this.student,
        });

        if (response.data.data.reduction_type) {
          this.student_reduction =
            response.data.data.reduction_type.reduction_type.name;
        } else {
          this.student_reduction = "";
        }
      } catch (error) {
        this.isLoading = false; this.updated = true;
        console.log("getStudentReductionType():", error);
      }
    },
    async getReductionTypes() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          "/api/reduction-types?page=" + this.pagination.current_page
        );
        if (response) {
          this.reduction_types = response.data.data.data;
          await this.getStudentReductionType();
          this.isLoading = false; this.updated = true;
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error");
      }
    },
    async addStatus($event) {
      if (!this.status.StatusID) {
        this.showAlert(this.$t("form.validation.invalidStatus"), "danger");
        return;
      }

      if (this.status.StatusName == "Graduated") {
        if (!(await this.markGraduated(false))) return;
      }

      this.studentStatus.push({
        StudentStatusID: this.status.StatusID,
        StudentStatusName: this.status.StatusName,
        StudentStatusComment: this.status.StatusComment,
        StudentStatusDate: this.datetomodel,
      });
      this.$bvModal.hide("uncheck_graduate_modal_alumni");
      this.statusCreateMode = false;
      this.statusCreateModeModal = false;
      this.student.CurrentStatus = this.status.StatusID;
      axios
        .put(`/api/alumni/${this.student.ID}/record-type`)
        .then((response) => {
          this.isLoading = false;
          this.updated = true;
          this.showAlert(response.data.message);
          this.saveStatuses($event);
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error saving statuses");
        });
    },

    saveStatuses($event) {
      let data = {
        status: [],
        student: {},
        graduate: 0,
      };

      this.studentStatus.forEach((status) =>
        data.status.push(JSON.stringify(status))
      );
      data.student.CurrentStatus = this.student.CurrentStatus;

      // update program & graduation requirements in case of Graduated Status
      if (this.studentProgram.Graduate) {
        data.graduate = 1;
        data.program = JSON.stringify(this.studentProgram);
        data.graduateReq = JSON.stringify(this.studentGraduateReq);
      }

      this.isLoading = true;

      axios
        .put(`/api/students/${this.student.ID}/statuses`, data)
        .then((response) => {
          this.isLoading = false;
          this.updated = true;
          this.showAlert(response.data.message);
          setTimeout(
            () =>
              this.$router.push({
                name: "StudentEdit",
                params: [
                  {
                    id: this.student.ID,
                  },
                ],
              }),
            2000
          );

          return true;

          if (response.data.data.statuses.length) {
            this.studentStatus = [];
            response.data.data.statuses.map((status) => {
              let s = status.pivot;
              s.StudentStatusName = status.StatusName;

              this.studentStatus.push(s);
            });
            this.getAudits("students");
            if (this.tabIndex == 0) {
              this.getStudent();
            } else if (this.tabIndex == 4) {
              this.updateStudent(false, $event);
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error saving statuses");
        });
    },

    toDayDate() {
      return moment().format(this.dateFormat);
    },
    onChangeStatusModal() {
      this.statusCreateModeModal = true;

      if (!this.status) {
        this.status = {
          StatusID: "",
          StatusName: "",
          StatusComment: "",
          StatusDate: this.formatDate(),
        };

        return;
      }

      this.status.StatusComment = null;
      this.status.StatusDate = this.toDayDate();
    },
    selectProgram(programID) {
      let program = this.programs.find((p) => p.ID === programID);

      if (!program) return;

      this.studentProgram.ProgramID = program.ID;
      this.selectedProgramCode = program.ProgramCode;
      this.programchanged = 1;
    },
    // Export Grades
    async exportGrades() {
      let token = await this.createToken("student-grades");

      if (token == "") return;

      let url = `/students/${this.student.ID}/grades?token=${token}`;

      window.open(url, "_blank");
    },

    /**
     * Export students list - PDF | Word | Text
     */
    async generate(method) {
      let token = await this.createToken("students-export");
      if (token == "") return;
      window.open(
        `/students/address/export?method=${method}&token=${token}&student=${this.$route.params.id}&mailaddress=${this.student.MailAddress}`,
        "_blank"
      );
    },

    async createToken() {
      let response = await axios.post("/api/api-tokens", {
        type: "alumni-attachment",
      });
      let token = "";

      if (response.status == 200) {
        token = response.data.extra[0].token;
      }

      return token;
    },

    async downloadRemarks() {
      let token = await this.createToken("student-remarks");

      if (token == "") return;

      window.open(
        `/students/${this.student.ID}/remarks?token=${token}`,
        "_blank"
      );
    },

    async downloadAttachment(file, isDownload = false) {
      let token = await this.createToken("student-attachment");
      if (token == "") return;

      // Encode the file name to handle special characters
      let encodedFileName = encodeURIComponent(file.Name);
      let encodedFilePath = encodeURIComponent(file.File);

      window.open(
        `/students/attachments/${encodedFileName}?id=${file.ID}&file=${encodedFilePath}&token=${token}&download=${isDownload}`,
        "_blank"
      );
    },

    /**
     * Paginate Invoices/Audits
     */
    paginate(method = null) {
      if (method === "invoice") {
        this.getStudentInvoices();
        return;
      }

      this.getAudits();
    },

    /**
     * Get list of student invoices
     */
    async getStudentInvoices() {
      this.checkInvoiceCall = false;

      if (
        this.isPartnerSchoolUser ||
        (!this.isAccountingUser && !this.groupsCanViewFinanceTab)
      )
        return;

      let url = `/api/alumni/${this.student.ID}/invoices?page=${this.pagination.current_page}`;

      if (this.invoiceType) url += `&type=${this.invoiceType}`;

      this.isLoading = true;
      try {
        const response = await axios.get(url);
        if (response) {
          this.studentInvoices = response.data.data.data;
          this.pagination = response.data.pagination;
          this.isLoading = false;
        }
      } catch (err) {
        console.log("error in getting invoices.");
      }
    },

    /**
     * Get list of alumni audits
     */
    async getAudits(entity = "alumni") {
      if (
        this.isPartnerSchoolUser ||
        this.isRecruitmentManagerUser ||
        this.isFrontOfficeUser
      ) {
        return;
      }

      this.loadingAudits = true;

      await axios
        .get(
          `/api/${entity}/${this.student.ID}/audits?page=${this.pagination_audit.current_page}`
        )
        .then((response) => {
          if (response.data) {
            this.loadingAudits = false;
            this.audits = response.data.data.data;
            this.pagination_audit = response.data.pagination;
            if (this.audits[19]) {
              this.audits[19].newValue = this.formatDate(
                this.audits[19].newValue
              );
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.loadingAudits = false;
        });
    },

    /**
     * Paginate Student/Audits
     */
    paginateAudit() {
      this.getAudits();
    },

    /**
     * Format Date
     */
    formatDate(format = "DD.MM.YYYY", date) {
      return moment(date).format(format);
    },

    /**
     * Set Student Profile Photo
     */
    profileUploaded(file, response) {
      this.isLoading = false;

      this.student.Photo = response.filename;
    },

    showSelectedImage() {
      let input = this.$refs.profile_image;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }

      let fd = new FormData();
      fd.append("file", file[0]);

      this.isLoading = true;
      axios
        .post("/api/students/profile-image", fd)
        .then((resp) => {
          this.student.Photo = resp.data.filename;
          this.isLoading = false; this.updated = true;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("file not found");
        });
    },

    /**
     * Upload file error on dropzone
     */
    uploadFileError(file, message) {
      this.showAlert(message.errors, "danger");
      this.isLoading = false;
    },

    /**
     * Uploaded Attachment Auto-save
     */
    attachmentUploaded(file, data) {
      this.loading = true;
      axios
        .post("/api/alumni/attachment/file/save", {
          Name: data.filename,
          File: `${data.student_number}/${data.id}/${data.filename}`,
          StudentID: this.student.ID,
          Description: "",
          AttachmentDate: this.formatDate(),
          UploadTimestamp: calculateTimeAsPerTimeZone("+2"),
        })
        .then((response) => {
          if (response.data) {
            this.attachments.push({
              ...response.data?.attachment,
              Name: data.filename,
              type: file.type,
            });
            this.showAlert(response.data.message);
            this.loading = false; this.updated = true;
          }
        })
        .catch((error) => {
          this.showAlert(
            error.response?.data?.message +
            " " +
            error.response?.data?.errors?.Name,
            "danger"
          );
          this.loading = false;
        });
    },

    /**
     * Remove attachmemnt from student attachment list
     */
    removeAttachment(index, attach) {
      let vm = this;

      if (confirm(this.$t("form.validation.delete"))) {
        axios
          .post("/api/deleteAttachFile", attach)
          .then((response) => {
            if (response.data.error) {
              this.showAlert(response.data.message, "warning");
            } else if (response.data.success) {
              vm.attachments.splice(index, 1);
              this.showAlert(response.data.message);
              this.updated = true;
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
              this.showAlert(error.response.data.message, "warning");
            } else {
              console.log("error", error);
            }
          });
      }
    },

    /**
     * Get Secondary Programs related to selected program
     */
    getSecondaryPrograms(program2ID = null) {
      let code = this.programCodesSecondaryMajor.find(
        (code) => code == this.selectedProgramCode
      );

      if (!code) {
        this.secondaryPrograms = [];
        return;
      }

      axios
        .get("/api/programs/secondary?code=" + code)
        .then((response) => {
          this.secondaryPrograms = response.data;
          this.secondaryPrograms = this.secondaryPrograms.map((program) => {
            program.FullTitle = this.$options.filters.program(program);

            return program;
          });

          // set previously selected program
          if (program2ID) {
            this.secondaryPrograms.find((sp) => {
              if (sp.ID === program2ID) {
                this.studentProgram2Title = sp.FullTitle;
                this.studentProgram.Program2ID = program2ID;
              }
            });
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error");
          this.isLoading = false;
        });
    },

    /**
     * Update alumni
     */
    updateStudent(shouldClose = false) {
      this.$v.$touch();

      if (this.disableEditForm) return;

      if (this.$v.$invalid) {
        let errorMsg = "";

        if (this.$v.student.FirstName.$error) {
          errorMsg = this.$t("form.student.firstName");
        }

        if (this.$v.student.LastName.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + this.$t("form.student.lastName")
            : this.$t("form.student.lastName");
        }

        if (this.$v.student.BirthPlace.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + this.$t("form.student.birthPlace")
            : this.$t("form.student.birthPlace");
        }

        if (this.$v.student.Email.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + this.$t("form.student.email")
            : this.$t("form.student.email");
        }

        if (this.$v.student.MatriculationNum.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", MatriculationNum"
            : "MatriculationNum";
        }

        if (this.$v.studentProgram.ThesisSubject.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + this.$t("form.student.thesisSubject")
            : this.$t("form.student.thesisSubject");
        }

        if (!this.isPartnerSchoolUser && this.isAccountingUser) {
          if (this.$v.studentFinance.GlobalDiscount.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Global Discount"
              : "Global Discount";
          }
          if (this.$v.studentFinance.FullPaymentDiscount.$error) {
            errorMsg = errorMsg
              ? errorMsg + ", Full Payment Discount"
              : "Full Payment Discount";
          }
        }
        
        if (this.$v.studentProgram.ThesisPercentage.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + this.$t("form.student.thesisPercentage")
            : this.$t("form.student.thesisPercentage");
        }

        if (this.$v.grades.$each.$error) {
          errorMsg = errorMsg
            ? errorMsg + ", " + $t("form.student.grade")
            : $t("form.student.grade");
        }

        this.showAlert(
          this.$t("form.validation.mandatoryFieldsError", {
            errors: errorMsg,
          }),
          "danger"
        );

        return;
      }

      if (
        this.studentProgram.Withdraw == true &&
        this.studentProgram.Graduate == true
      ) {
        this.showAlert(
          this.$t("form.student.NotEqualWithdrawnAndGraduated"),
          "danger"
        );
        return;
      }

      if (this.graduatecheckboxchanged == 1 && this.graduatecheckbox == false) {
        this.$bvModal.show("uncheck_graduate_modal_alumni");
        this.shouldnotclose = 1;
      }
      this.isLoading = true;

      let attachments = [];
      this.attachments.map((attach) =>
        attachments.push(JSON.stringify(attach))
      );

      this.student.FullPaymentDiscount =
        this.studentFinance.FullPaymentDiscount;
      this.student.GlobalDiscount =
        this.studentFinance.GlobalDiscount == "" ||
          this.studentFinance.GlobalDiscount == null
          ? 0
          : this.studentFinance.GlobalDiscount;
      let data = {
        student: JSON.stringify(this.student),
        bussiness: JSON.stringify(this.studentBussiness),
        attachments: attachments,
        program: JSON.stringify(this.studentProgram),
        student_reduction: this.student_reduction,
      };
      axios
        .put(`/api/alumni/${this.student.ID}`, data)
        .then((response) => {
          this.isLoading = false;
          this.updated = true;
          if (response.data.error) {
            this.showAlert(response.data.message, "danger");
          } else if (response.data.success) {
            clearInterval(this.interval);

            // setting data instead of api call to getStudent
            var apiResponse = response.data;
            this.setStudentData(apiResponse);

            if (this.programchanged == 1) {
              this.getStudent(function () {
                this.programchanged = 0;
              });
            }
            this.showAlert(response.data.message);
            if (shouldClose) {
              if (this.shouldnotclose != 1) {
                setTimeout(() => {
                  this.$router
                    .push({
                      name: "AlumniIndex",
                    })
                    .catch(() => { });
                }, 2000);
                return;
              }
            }
            this.getAudits();
            this.closing = true;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error.response);
        });
    },

    /**
     * Show alert
     */
    showAlert(msg, cls = "success") {
      this.alertMessage = msg;
      this.alertClass = cls;
      this.alert = true;
    },

    /**
     * Partner selected
     */
    selectedPartner() {
      this.student.PartnerCampusID = null;

      this.fetchPartnerCampus();
    },

    /**
     * Fetch partner campuses for selected partner
     */
    async fetchPartnerCampus() {
      if (!this.student.PartnerID) return;
      try {
        const response = await axios.get(
          `/api/campuses?full&PartnerID=${this.student.PartnerID}`
        );
        if (response.data) {
          this.partnercampus = response.data;
        }
      } catch (error) {
        console.log("error fetching partner campuses");
      }
    },

    changeCheck($event) {
      if (event.target.value == "0") event.target.value = 1;
      else event.target.value = 0;
      if ($event.target.name == "graduatecheck") {
        this.graduatecheckboxchanged = 1;
        if (this.graduatecheckbox == true) {
          this.studentProgram.Graduate = -1;
        } else if (this.graduatecheckbox == false) {
          this.studentProgram.Graduate = 0;
        }
      }
    },

    /**
     * Get initials data for form
     */
    async getInitialData() {
      try {
        const response = await axios.get("/api/students/initial-data");
        if (response.data) {
          const data = response.data;
          this.userPartnerCode = data.user_partner_code;
          this.gradingScales = data.grading_scale;
          this.defaultGradingScaleTypeId = data.default_grading_scale_type_id;
          this.partners = data.partners;
          this.countries = data.countries;
          this.titles = data.titles;
          this.descriptiveGrades = data.descriptiveGrades;
          this.ECTSGrades = data.ECTSGrades;
          this.partnersDisabled = data.partnersDisabled; // disabled partners select
          this.isAccountingUser = data.isAccountingUser;
          this.paymentPlans = data.paymentPlans;
          this.foundationAllowedCodes = data.foundation_program_codes;

          this.programCodesSecondaryMajor = data.programCodes_secondaryMajor;
          this.perPageAudits = data.auditsPaginate;

          this.statusList = data.status;
          this.statusList.map((status) => {
            status.StatusComment = "";
            status.StatusDate = this.formatDate();
          });

          this.professor = data.professors;
          this.professor.map(
            (p) => (p.FullName = `${p.FirstName} ${p.LastName}`)
          );
          this.programs = data.programs;
          this.programs.map(
            (p) => (p.FullTitle = this.$options.filters.program(p))
          );
        }
      } catch (error) {
        console.log("Error fetching data");
      }
    },

    /**
     * Edit check call for currently editing user(s) for same record.
     */

    checkForEdit(refresh = false) {
      if (refresh) this.continueInterVal = true;
      let data = {
        field_id: this.$route.params.id,
        form: this.$route.name,
        refresh: refresh,
      };
      axios
        .post("/api/check-for-edit-session", data)
        .then((response) => {
          this.sessionCreated = true;
          if (response.data.warning == 0) {
            this.disableEditForm = false;
            this.showDisableAlert = false;
            if (this.firstLoad) {
              this.firstLoad = false;
            }
          }

          if (response.data.warning == -1) {
            this.disableEditForm = false;
            this.showDisableAlert = false;
          }

          if (response.data.warning == 1) {
            this.firstLoad = false;
            this.disableEditFormMessage = response.data.message;
            this.disableEditForm = true;
            this.showDisableAlert = true;
            this.continueInterVal = false;
          }

          if (response.data.warning == 2) {
            let msg = response.data.message;
            if (this.firstLoad) {
              msg.replace("re-open", "open");
            }
            this.sessionCreated = false;
            this.disableEditFormMessage = msg;
            this.disableEditForm = true;
            this.showDisableAlert = true;
          }
          if (response.data.warning == 3) {
            this.disableEditForm = false;
            this.showDisableAlert = true;
            this.disableEditFormMessage = response.data.message;
          }
        })
        .catch((error) => {
          console.log("error");
        });
    },

    /**
     * setting student data from response
     */
    async setStudentData(response) {
      this.student = response.data.student;
      localStorage.setItem("get-student", JSON.stringify(response.data.student));
      this.student.BirthDate = this.student.BirthDate
        ? moment(this.student.BirthDate).format(this.dateFormat)
        : null;

      this.student.PermitExpiry = this.student.PermitExpiry
        ? moment(this.student.PermitExpiry).format(this.dateFormat)
        : null;

      this.student.PassportExpiry = this.student.PassportExpiry
        ? moment(this.student.PassportExpiry).format(this.dateFormat)
        : null;

      if (response.data.program.pivot.Graduate == -1) {
        this.graduatecheckbox = true;
      } else {
        this.graduatecheckbox = false;
      }
      if (this.student.FullPaymentDiscount == null) {
        this.studentFinance.FullPaymentDiscount =
          this.defaultFullPaymentDiscount;
      } else {
        this.studentFinance.FullPaymentDiscount =
          this.student.FullPaymentDiscount;
      }
      this.studentFinance.GlobalDiscount = this.student.GlobalDiscount;

      if (response.data.grades.length != 0) {
        for (var i = 0; i < response.data.grades.length; i++) {
          if (
            response.data.program.ProgramCode == "EMBA" &&
            response.data.grades[i].CourseCode == "THE770"
          ) {
            this.gradeDetails = response.data.grades[i].pivot;
          } else if (
            response.data.program.ProgramCode == "DBA" &&
            response.data.grades[i].CourseCode == "DOC700"
          ) {
            this.gradeDetails = response.data.grades[i].pivot;
          } else if (
            (response.data.program.ProgramCode == "AAE" ||
              response.data.program.ProgramCode == "BBA") &&
            response.data.grades[i].CourseCode == "THE350"
          ) {
            this.gradeDetails = response.data.grades[i].pivot;
          } else if (
            response.data.program.ProgramCode != "EMBA" &&
            response.data.program.ProgramCode != "DBA" &&
            response.data.program.ProgramCode != "BBA" &&
            response.data.program.ProgramCode != "AAE" &&
            response.data.grades[i].CourseCode == "THE755"
          ) {
            this.gradeDetails = response.data.grades[i].pivot;
          }
        }
      }

      if (response.data.gpa.gpa) this.gpa = response.data.gpa.gpa;

      if (response.data.localGpa.local_gpa) {
        this.localGpa = response.data.localGpa.local_gpa;
      }

      if (response.data.fp_gpa) {
        this.fpGpa = response.data.fp_gpa.gpa;
      }

      if (response.data.fp_localGpa) {
        this.fpLocalGpa = response.data.fp_localGpa.local_gpa;
      }

      if (this.student.Photo) {
        this.getImage(`/api/students/${this.student.ID}/profile-image`);
      }

      if (this.student.ProgramStart) {
        this.student.ProgramStart = this.student.ProgramStart
          ? moment(this.student.ProgramStart).format(
            this.dateFormat
          )
          : this.student.ProgramStart;
      }

      if (response.data.bussiness != null)
        this.studentBussiness = response.data.bussiness;

      if (response.data.addmission != null) {
        this.studentAdmission = response.data.addmission;
      }

      if (response.data.gradutionReq != null) {
        this.studentGraduateReq = response.data.gradutionReq;

        if (this.studentGraduateReq.DBAEApprovalDate) {
          this.studentGraduateReq.DBAEApprovalDate = moment(
            this.studentGraduateReq.DBAEApprovalDate
          ).format(this.dateFormat);
        }

        if (this.studentGraduateReq.DBAStatsExamDate) {
          this.studentGraduateReq.DBAStatsExamDate = moment(
            this.studentGraduateReq.DBAStatsExamDate
          ).format(this.dateFormat);
        }

        if (this.studentGraduateReq.DBACompsDate) {
          this.studentGraduateReq.DBACompsDate = moment(
            this.studentGraduateReq.DBACompsDate
          ).format(this.dateFormat);
        }

        if (this.studentGraduateReq.DBAMADate) {
          this.studentGraduateReq.DBAMADate = moment(
            this.studentGraduateReq.DBAMADate
          ).format(this.dateFormat);
        }

        if (this.studentGraduateReq.DBADODDate) {
          this.studentGraduateReq.DBADODDate = moment(
            this.studentGraduateReq.DBADODDate
          ).format(this.dateFormat);
        }

        if (this.studentGraduateReq.DBADegreeIssueDate) {
          this.studentGraduateReq.DBADegreeIssueDate = moment(
            this.studentGraduateReq.DBADegreeIssueDate
          ).format(this.dateFormat);
        }
      }

      // Status
      if (response.data.status.length != 0) {
        this.studentStatus = [];

        response.data.status.map((status) => {
          let s = status.pivot;
          s.StudentStatusName = status.StatusName;

          this.studentStatus.push(s);
        });
      }

      // Grades
      if (response.data.grades.length != 0) {
        this.grades = [];

        response.data.grades.map((course) => {
          let c = course.pivot;
          c.CourseTitle = course.CourseTitle;
          c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;

          if (c.FinalExameDate) {
            c.FinalExameDate = moment(c.FinalExameDate).format(this.dateFormat);
          }

          this.grades.push(c);
        });
      }

      if (response.data.program) {
        const program = response.data.program;

        this.studentPaymentSummary.IntroText = `We herewith confirm receipt of the following payments to date, toward tuition fees, regarding the ${program.ProgramTitle} ${program.ProgramCode} (${program.ProgramType}) program you are currently enrolled in:`;

        let student = JSON.parse(localStorage.getItem("get-student"));
        let id = student.programs[0].FoundationID;
        if (this.foundationAllowedCodes.includes(student.programs[0].ProgramCode) && id != null) {
          this.foundationGrades = true;
          this.foundationProgram = this.programs.find(p => p.ID === id);

          axios
            .get(`/api/programs/${id}/courses`)
            .then(response => {
              this.fpCourses = response.data;
              this.fpCourses.map(
                c =>
                  (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
              );
            })
            .catch(error => {
              console.log(error.response);
            });
        }

        this.selectedProgramCode = program.ProgramCode;
        /*SET Value of Program TAB */
        this.studentProgram = program.pivot;
        this.studentProgram.FoundationID = program.FoundationID;
        this.studentProgram.GraduationDate = moment(
          this.studentProgram.GraduationDate
        ).format(this.dateFormat);

        if (this.studentProgram.Program2ID) {
          /* This function needs to await*/
          await this.getSecondaryPrograms(this.studentProgram.Program2ID);
        }

        if (this.studentProgram.Graduate != -1) {
          this.studentProgram.Graduate = null;
        }
      }

      // Foundation Program Grades
      if (response.data.fp_grades) {
        if (response.data.fp_grades.length != 0) {
          this.fpGrades = [];

          response.data.fp_grades.map(course => {
            let c = course.pivot;
            c.CourseTitle = course.CourseTitle;
            c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;
            c.FinalExameDate = moment(c.FinalExameDate).format(this.dateFormat);
            if (c.Percentage == null && c.Grade == null && c.DescriptiveGrade == null && parseFloat(c.LocalGrade) < 4.0 && this.student.PartnerID == 1) {
              c.DescriptiveGrade = "F";
            }

            this.fpGrades.push(c);
          });
        }
      }

      // Secondary Grades
      if (response.data.secondary_grades.length != 0) {
        this.secondaryGrades = [];

        response.data.secondary_grades.map((course) => {
          let c = course.pivot;
          c.CourseTitle = course.CourseTitle;
          c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;

          if (c.FinalExameDate) {
            c.FinalExameDate = moment(c.FinalExameDate).format(this.dateFormat);
          }

          this.secondaryGrades.push(c);
        });
      }

      // Attachments
      if (response.data.attachments.length != 0) {
        this.attachments = [];

        response.data.attachments.map((attach) => {
          let a = attach;
          a.Name = this.getAttachmentFileName(a.File);
          a.UploadTimestamp = a.UploadTimestamp
            ? moment(a.UploadTimestamp).format(this.datetimeFormat)
            : null;
          this.attachments.push(a);
        });
      }

      // Student Absences
      if (response.data.studentAbsences.length != 0) {
        this.studentAbsences = response.data.studentAbsences;
      }

      if (response.data.application != null) {
        this.studentApplication.CurriculumVitae = response.data.application
          .CurriculumVitae
          ? response.data.application.CurriculumVitae
          : [];

        this.studentApplication.Degree = response.data.application.Degree
          ? response.data.application.Degree
          : [];

        this.studentApplication.Transcript = response.data.application
          .Transcript
          ? response.data.application.Transcript
          : [];

        this.studentApplication.Letter = response.data.application.Letter
          ? response.data.application.Letter
          : [];

        this.studentApplication.Picture = response.data.application.Picture
          ? response.data.application.Picture
          : [];

        this.studentApplication.AdditionalDocuments = response.data.application
          .AdditionalDocuments
          ? response.data.application.AdditionalDocuments
          : [];

        this.studentApplication.PassportCopy = response.data.application
          .PassportCopy
          ? response.data.application.PassportCopy
          : [];

        this.studentApplication.PermitCopy = response.data.application
          .PermitCopy
          ? response.data.application.PermitCopy
          : [];

        this.studentApplication.Score = response.data.application.Score
          ? response.data.application.Score
          : "";

        this.studentApplication.EnglishProficiency = response.data.application
          .EnglishProficiency
          ? response.data.application.EnglishProficiency
          : [];

        this.studentApplication.ResearchInterestOutline = response.data
          .application.ResearchInterestOutline
          ? response.data.application.ResearchInterestOutline
          : [];

        this.studentApplication.ValidCurriculumVitae = response.data.application
          .ValidCurriculumVitae
          ? response.data.application.ValidCurriculumVitae
          : false;

        this.studentApplication.ValidDegree = response.data.application
          .ValidDegree
          ? response.data.application.ValidDegree
          : false;

        this.studentApplication.ValidTranscript = response.data.application
          .ValidTranscript
          ? response.data.application.ValidTranscript
          : false;

        this.studentApplication.ValidLetter = response.data.application
          .ValidLetter
          ? response.data.application.ValidLetter
          : false;

        this.studentApplication.ValidPicture = response.data.application
          .ValidPicture
          ? response.data.application.ValidPicture
          : false;

        this.studentApplication.ValidEnglishProficiency = response.data
          .application.ValidEnglishProficiency
          ? response.data.application.ValidEnglishProficiency
          : false;

        this.studentApplication.ValidResearchInterestOutline = response.data
          .application.ValidResearchInterestOutline
          ? response.data.application.ValidResearchInterestOutline
          : false;
        this.studentApplication.ValidAssociateDegree = response.data.application
          .ValidAssociateDegree
          ? response.data.application.ValidAssociateDegree
          : false;

        this.studentApplication.ValidPassportCopy = response.data.application
          .ValidPassportCopy
          ? response.data.application.ValidPassportCopy
          : false;

        this.studentApplication.ValidPermitCopy = response.data.application
          .ValidPermitCopy
          ? response.data.application.ValidPermitCopy
          : false;

        this.studentApplication.AssociateDegree = response.data.application
          .AssociateDegree
          ? response.data.application.AssociateDegree
          : [];

        if (
          typeof this.studentApplication.ResearchInterestOutline == "string" &&
          this.studentApplication.ResearchInterestOutline != ""
        ) {
          this.studentApplication.ResearchInterestOutline = JSON.parse(
            this.studentApplication.ResearchInterestOutline
          );
        }

        if (
          typeof this.studentApplication.PermitCopy == "string" &&
          this.studentApplication.PermitCopy != ""
        ) {
          this.studentApplication.PermitCopy = JSON.parse(
            this.studentApplication.PermitCopy
          );
        }

        if (
          typeof this.studentApplication.PassportCopy == "string" &&
          this.studentApplication.PassportCopy != ""
        ) {
          this.studentApplication.PassportCopy = JSON.parse(
            this.studentApplication.PassportCopy
          );
        }

        if (
          typeof this.studentApplication.AdditionalDocuments == "string" &&
          this.studentApplication.AdditionalDocuments != ""
        ) {
          this.studentApplication.AdditionalDocuments = JSON.parse(
            this.studentApplication.AdditionalDocuments
          );
        }

        if (
          typeof this.studentApplication.Picture == "string" &&
          this.studentApplication.Picture != ""
        ) {
          this.studentApplication.Picture = JSON.parse(
            this.studentApplication.Picture
          );
        }

        if (
          typeof this.studentApplication.Letter == "string" &&
          this.studentApplication.Letter != ""
        ) {
          this.studentApplication.Letter = JSON.parse(
            this.studentApplication.Letter
          );
        }

        if (
          typeof this.studentApplication.Transcript == "string" &&
          this.studentApplication.Transcript != ""
        ) {
          this.studentApplication.Transcript = JSON.parse(
            this.studentApplication.Transcript
          );
        }

        if (
          typeof this.studentApplication.Degree == "string" &&
          this.studentApplication.Degree != ""
        ) {
          this.studentApplication.Degree = JSON.parse(
            this.studentApplication.Degree
          );
        }

        if (
          typeof this.studentApplication.CurriculumVitae == "string" &&
          this.studentApplication.CurriculumVitae != ""
        ) {
          this.studentApplication.CurriculumVitae = JSON.parse(
            this.studentApplication.CurriculumVitae
          );
        }

        if (
          typeof this.studentApplication.EnglishProficiency == "string" &&
          this.studentApplication.EnglishProficiency != ""
        ) {
          this.studentApplication.EnglishProficiency = JSON.parse(
            this.studentApplication.EnglishProficiency
          );
        }

        if (
          typeof this.studentApplication.AssociateDegree == "string" &&
          this.studentApplication.AssociateDegree != ""
        ) {
          this.studentApplication.AssociateDegree = JSON.parse(
            this.studentApplication.AssociateDegree
          );
        }

        if (
          typeof this.studentApplication.ResearchInterestOutline == "object" &&
          this.studentApplication.ResearchInterestOutline != ""
        ) {
          this.studentApplication.ResearchInterestOutline = Object.values(
            this.studentApplication.ResearchInterestOutline
          );
        }

        if (
          typeof this.studentApplication.PassportCopy == "object" &&
          this.studentApplication.PassportCopy != ""
        ) {
          this.studentApplication.PassportCopy = Object.values(
            this.studentApplication.PassportCopy
          );
        }

        if (
          typeof this.studentApplication.PermitCopy == "object" &&
          this.studentApplication.PermitCopy != ""
        ) {
          this.studentApplication.PermitCopy = Object.values(
            this.studentApplication.PermitCopy
          );
        }

        if (
          typeof this.studentApplication.AdditionalDocuments == "object" &&
          this.studentApplication.AdditionalDocuments != ""
        ) {
          this.studentApplication.AdditionalDocuments = Object.values(
            this.studentApplication.AdditionalDocuments
          );
        }

        if (
          typeof this.studentApplication.Picture == "object" &&
          this.studentApplication.Picture != ""
        ) {
          this.studentApplication.Picture = Object.values(
            this.studentApplication.Picture
          );
        }

        if (
          typeof this.studentApplication.Letter == "object" &&
          this.studentApplication.Letter != ""
        ) {
          this.studentApplication.Letter = Object.values(
            this.studentApplication.Letter
          );
        }

        if (
          typeof this.studentApplication.Transcript == "object" &&
          this.studentApplication.Transcript != ""
        ) {
          this.studentApplication.Transcript = Object.values(
            this.studentApplication.Transcript
          );
        }

        if (
          typeof this.studentApplication.Degree == "object" &&
          this.studentApplication.Degree != ""
        ) {
          this.studentApplication.Degree = Object.values(
            this.studentApplication.Degree
          );
        }

        if (
          typeof this.studentApplication.CurriculumVitae == "object" &&
          this.studentApplication.CurriculumVitae != ""
        ) {
          this.studentApplication.CurriculumVitae = Object.values(
            this.studentApplication.CurriculumVitae
          );
        }

        if (
          typeof this.studentApplication.EnglishProficiency == "object" &&
          this.studentApplication.EnglishProficiency != ""
        ) {
          this.studentApplication.EnglishProficiency = Object.values(
            this.studentApplication.EnglishProficiency
          );
        }

        if (
          typeof this.studentApplication.AssociateDegree == "object" &&
          this.studentApplication.AssociateDegree != ""
        ) {
          this.studentApplication.AssociateDegree = Object.values(
            this.studentApplication.AssociateDegree
          );
        }
      }
    },
    /**
     * Get alumni
     */
    async getStudent(isCheckCall = false) {
      this.isLoading = true;
      try {
        const response = await axios.get(
          "/api/alumni/" + this.$route.params.id + "/edit"
        );

        if (response.data) {
          var apiResponse = response;
          let program2ID = null;
          this.student = response.data.student;

          if (this.student.programs) {
            this.program1Type = this.student.programs[0].ProgramType;
            if (this.student.programs2.length > 0) {
              this.program2Type = this.student.programs2[0].ProgramType;
            }
            this.coursesArr = this.student.course;
            this.courses2Arr = this.student.course2;
          } else {
            console.log('No program assigned to record.');
          }

          this.setStudentData(apiResponse);

          if (this.studentInvoices.length == 0) this.getStudentInvoices();

          this.getStudentPaymentSummaries();

          // Fetch Partner Call here to prevent v-select issue
          if (!isCheckCall) {
            await this.fetchPartnerCampus();
          }

          this.updateCalled = 0;
          if (!this.permissions.editAlumniProgram) {
            this.$refs.thesisEvaluationDropzone.disable();
          }

          this.getAudits();
          this.isLoading = false;
        }
      } catch (errors) {
        this.isLoading = false;

        if (errors.response) {
          let response = errors.response;

          if (response.status == 404) {
            this.showAlert(response.data.message, "warning");

            setTimeout(
              () =>
                this.$router.push({
                  name: "AlumniIndex",
                }),
              2000
            );
          }
        }
      }
    },

    // get student profile image
    getImage(url) {
      axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          this.image = this.imageEncode(response);
        });
    },

    // encode image to base64
    imageEncode(response) {
      let arrayBuffer = response.data;
      let b64encoded = btoa(
        [].reduce.call(
          new Uint8Array(arrayBuffer),
          (p, c) => p + String.fromCharCode(c),
          ""
        )
      );
      let mimetype = response.headers["content-type"].toLowerCase();

      return `data:${mimetype};base64,${b64encoded}`;
    },
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.interval);
    if (this.closing || this.updated) next();
    else {
      const answer = window.confirm(this.$t("leavePrompt"));

      if (answer) {
        next();
      } else {
        localStorage.removeItem("summary-tab");
        next(false);
      }
    }
  },
};
</script>

<style scoped>
.icon-overlay {
  bottom: 10px;
  pointer-events: none;
}

button {
  pointer-events: all;
}

.date-picker.is-invalid {
  border-color: #dc3545;
  border-style: double;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: black !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: black !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: black !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: black !important;
}

body {
  background-color: #e2e2e2;
}

#dropzone2 {
  padding: 0;
  margin: 0;
}

#app {
  padding: 20px;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}

input[type="date"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}

.custom-validate {
  display: block !important;
}

.grades-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 5px;
  background-color: #fff;
  padding: 2rem;
}

.grades-btns button,
.gpa-box {
  min-width: 150px;
  text-align: center;
}

.gpa-box {
  display: inline-block;
  font-size: 110%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0.35rem;
  margin-top: 1rem;
}

@media only screen and (min-width: 1900px) {
  .grades-btns {
    flex-direction: row;
    justify-content: space-between;
  }

  .gpa-box {
    text-align: center;
    padding: 2rem;
    margin-top: 0;
  }
}
</style>